import React, { useEffect, useMemo, useRef, useState } from "react";
import "./capability-cloud.css";
import vodPosterTokyo from "./vod-poster-tokyo.jpg";

// --- Precision Lucide-style SVG Vector Icons ---
const Icon = ({ name, size = 16, className = "" }) => {
  const icons = {
    overview: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" />
      </svg>
    ),
    vod: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" /><line x1="7" y1="2" x2="7" y2="22" /><line x1="17" y1="2" x2="17" y2="22" /><line x1="2" y1="12" x2="22" y2="12" /><line x1="2" y1="7" x2="7" y2="7" /><line x1="2" y1="17" x2="7" y2="17" /><line x1="17" y1="17" x2="22" y2="17" /><line x1="17" y1="7" x2="22" y2="7" />
      </svg>
    ),
    film: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" /><line x1="7" y1="2" x2="7" y2="22" /><line x1="17" y1="2" x2="17" y2="22" /><line x1="2" y1="12" x2="22" y2="12" /><line x1="2" y1="7" x2="7" y2="7" /><line x1="2" y1="17" x2="7" y2="17" /><line x1="17" y1="17" x2="22" y2="17" /><line x1="17" y1="7" x2="22" y2="7" />
      </svg>
    ),
    studio: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
      </svg>
    ),
    catalog: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" />
      </svg>
    ),
    jobs: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
    keys: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M21 2l-2 2m-1.5 1.5L14 9l-1.5-1.5L11 9l-2-2m-1.5 1.5L6 10l-1.5-1.5L3 10m9-8a6 6 0 1 0 8.49 8.49L12 19l-4 3 1-4-2-2-4 1 3-4-2-2 4-1" />
      </svg>
    ),
    usage: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
    analytics: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /><path d="M4 4l7 7 4-4 5 5" />
      </svg>
    ),
    logs: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="4 17 10 11 4 5" /><line x1="12" y1="19" x2="20" y2="19" />
      </svg>
    ),
    security: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    play: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
        <polygon points="5 3 19 12 5 21 5 3" />
      </svg>
    ),
    pause: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
        <rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" />
      </svg>
    ),
    volume: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
      </svg>
    ),
    volumeX: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" /><line x1="23" y1="9" x2="17" y2="15" /><line x1="17" y1="9" x2="23" y2="15" />
      </svg>
    ),
    maximize: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
      </svg>
    ),
    minimize: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M4 14h6m0 0v6m0-6L3 21m17-7h-6m0 0v6m0-6l7 7M4 10h6m0 0V4m0 6L3 3m17 7h-6m0 0V4m0 6l7-7" />
      </svg>
    ),
    theater: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="2" y="4" width="20" height="16" rx="2" /><line x1="2" y1="8" x2="22" y2="8" /><line x1="2" y1="16" x2="22" y2="16" />
      </svg>
    ),
    subtitles: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="2" y="4" width="20" height="16" rx="2" /><path d="M7 15h4M15 15h2M7 11h2M13 11h4" />
      </svg>
    ),
    check: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    copy: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
      </svg>
    ),
    download: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
      </svg>
    ),
    chevronRight: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="9 18 15 12 9 6" />
      </svg>
    ),
    chevronDown: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="6 9 12 15 18 9" />
      </svg>
    ),
    search: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
    sparkles: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z" />
      </svg>
    ),
    zap: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
    clock: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    server: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="2" y="2" width="20" height="8" rx="2" ry="2" /><rect x="2" y="14" width="20" height="8" rx="2" ry="2" /><line x1="6" y1="6" x2="6.01" y2="6" /><line x1="6" y1="18" x2="6.01" y2="18" />
      </svg>
    ),
    shield: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    bell: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    ),
    external: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
      </svg>
    ),
    sliders: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" /><line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" /><line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" />
      </svg>
    ),
    terminal: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="4 17 10 11 4 5" /><line x1="12" y1="19" x2="20" y2="19" />
      </svg>
    ),
    globe: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    layers: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" />
      </svg>
    ),
    refresh: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
      </svg>
    ),
    share: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
      </svg>
    ),
    billing: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" />
      </svg>
    ),
    finance: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" /><path d="M4 6v12a2 2 0 0 0 2 2h14v-4" /><path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z" />
      </svg>
    ),
    activity: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
    creditCard: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    ),
  };
  return icons[name] || null;
};

// --- Bilingual Translation Dictionary (i18n) ---
const i18n = {
  zh: {
    brandConsole: "云控制台",
    services: "服务目录",
    searchPlaceholder: "搜索能力产品、任务、点播媒资或端点 (Ctrl + K)",
    regionLabel: "ap-southeast-1 (新加坡主节点)",
    corporateSite: "返回官网",
    operational: "全部服务集群正常",
    operationalStatus: "所有节点在线",
    heroTitle: "控制台工作总览",
    heroDesc: "集中管理您的音视频点播媒资、AI 创作流水线与 API 运行资源。",
    openStudio: "进入 AI Studio 工坊",
    exploreCatalog: "浏览能力名录",
    exploreVod: "探索音视频点播大厅",
    manageKeys: "管理 API 密钥",
    radarTitle: "全球边缘网络监测",
    radarTelemetry: "实时网络遥测",
    mtdSpend: "本月实时消费",
    budgetUsed: "已使用预算",
    clusterSlaMetric: "集群服务就绪度",
    clusterSlaVal: "99.99% SLA",
    clusterSlaSub: "8 大边缘算力节点健康待命",
    vodAssetsMetric: "已就绪点播媒资",
    vodAssetsVal: "128 部",
    vodAssetsSub: "4K HEVC / AV1 自适应就绪",
    totalInvocations: "30天点播与调用",
    vsLastMonth: "较上月环比",
    vodBandwidthMetric: "存储与出网带宽",
    vodBandwidthSub: "已分配存储与出网带宽",
    gatewayStatusMetric: "网关与节点状态",
    gatewayStatusVal: "正常就绪 (Ready)",
    gatewayStatusSub: "所有转码节点健康待命",
    activeCaps: "就绪能力数",
    productionReady: "点播与模型均就绪",
    chartTitle: "点播吞吐与工作负载 (14天)",
    chartSubtitle: "聚合 VOD 流量带宽、并发点播播放与 API 推理吞吐指标",
    viewAnalytics: "查看点播分析",
    quickstartTitle: "产品级点播与开发接入",
    quickstartSubtitle: "3分钟完成全流程 AI 视频生成、转码切片与边缘分发",
    step1Title: "创建生产环境 API 密钥",
    step1Desc: "为组织 Goldly Labs 自动签发鉴权令牌",
    step2Title: "在 AI Studio 调试提示词与运镜",
    step2Desc: "实测视频镜头推拉摇移、时序稳定性与 JSON",
    step3Title: "一键同步发布至点播媒资库",
    step3Desc: "自动执行 H.265 / AV1 自适应切片转码与超分",
    step4Title: "通过 Web SDK / HLS 点播流集成",
    step4Desc: "获得毫秒级首帧加载与防盗链流媒体播放",
    servicesDirectory: "服务能力列表",
    recentJobsTitle: "近期任务与转码流水线",
    recentJobsSubtitle: "生产环境最新派发的音视频转码、AI 超分与推理计算任务",
    viewAllJobs: "查看全部流水线",
    jobId: "流水线任务标识",
    capability: "业务类型",
    operation: "处理动作",
    status: "状态",
    consumption: "资源规格",
    latency: "处理耗时",
    dispatched: "派发时间",
    estimatedCost: "预估费用",
    actions: "操作",
    details: "详情",
    studioTitle: "AI 创作与生成工坊",
    studioPath: "AI 工坊",
    tryPresets: "一键加载场景预设:",
    systemPromptTitle: "系统级指令 & 业务护栏 (可选配置)",
    systemPromptPlaceholder: "设定 AI 角色、业务上下文、输出边界与负向约束...",
    userPromptLabel: "提示词与场景导演描述 (Prompt)",
    charLimit: "字符数",
    aspectRatio: "画幅比例",
    styleAesthetic: "艺术风格预设",
    sequenceDuration: "视频生成时长",
    cameraDynamic: "镜头运动轨迹",
    endpointLabel: "API 路径",
    estSLA: "预计耗时",
    clear: "清空",
    runTask: "执行生成任务",
    processing: "正在进行时序渲染与切片...",
    liveResult: "实时渲染结果",
    rawJson: "标准化 JSON 契约",
    integrationCode: "多语言集成代码",
    copyOutput: "复制输出",
    copyCode: "复制代码",
    copied: "已复制到剪贴板",
    profileTier: "推理性能档位",
    tierFast: "极速档 (Fast)",
    tierFastDesc: "极低延迟 · 适用于高频交互",
    tierBalanced: "平衡档 (Balanced)",
    tierBalancedDesc: "企业推荐 · 性能与画质兼备",
    tierQuality: "电影级高精度 (Quality)",
    tierQualityDesc: "深度时序推理 · 复杂运镜首选",
    temperature: "采样温度 (创造力)",
    maxTokens: "最大输出长度",
    streaming: "SSE 流式传输 (实时输出)",
    zeroRetention: "零数据留存保障",
    zeroRetentionDesc: "用户输入与视频源不纳入任何公开训练",
    multiZoneFailover: "多可用区无损热备",
    multiZoneFailoverDesc: "秒级故障转移与流量再平衡",
    catalogTitle: "模型与能力产品目录",
    catalogDesc: "全模态企业级 AI 能力与点播分发矩阵，统一样式与单一密钥计费。",
    searchCatalog: "搜索能力、点播模板或端点...",
    standardsTitle: "企业级基础设施标准承诺",
    allJobs: "全部任务",
    running: "运行中",
    succeeded: "已成功",
    failed: "失败",
    exportCsv: "导出 CSV",
    apiKeysTitle: "API 密钥与播放鉴权",
    apiKeysDesc: "安全管理生产环境令牌、播放 Token 与 CDN 防盗链凭据。",
    createKey: "创建新密钥",
    keySecurityTip: "点播密钥最佳实践",
    keySecurityDesc: "播放防盗链 Token 建议由后端按时效动态签发，严禁在前端硬编码永久密钥。",
    usageTitle: "资源用量与限额配额",
    usageDesc: "实时监控算力集群 GPU 小时、音视频点播带宽、持久化存储空间与 API 并发配额。",
    requestQuota: "申请扩容配额",
    exportUsage: "导出用量明细",
    billingNav: "费用总览与账单",
    financeNav: "财务记账与充值",
    billingTitle: "费用总览与月度账单",
    billingDesc: "查看企业实时计费消耗、按量付费明细、月度出账单与官方增值税发票凭证。",
    financeTitle: "企业财务记账与资金充值",
    financeDesc: "管理企业资金账户可用余额、资金明细流水台账、对公银行转账充值与发票抬头资质。",
    downloadInvoice: "下载当月账单",
    editBudget: "调整预算限额",
    logsTitle: "API 运行日志与分布式链路追踪",
    logsDesc: "毫秒级分布式追踪，点播首帧耗时与全量请求审计追溯。",
    liveTail: "实时滚动日志",
    securityTitle: "访问控制与点播防盗链安全",
    securityDesc: "基于角色的访问权限 (RBAC)、HLS 128-bit AES 动态加密与防盗链白名单。",
    inviteMember: "邀请组织成员",
    environment: "当前环境",
    production: "生产环境 (Primary)",
    staging: "预发环境 (Staging)",
    development: "开发沙箱 (Sandbox)",
    projectContext: "当前项目",
    prodApps: "生产线核心应用",

    // VOD specific keys
    vodTitle: "音视频点播与智能媒资库",
    vodSubtitle: "产品级端到端点播服务：从 AI 视频生成、自适应多码率转码 (H.265/AV1)、超分修复到低延迟边缘点播分发。",
    filterAll: "全部媒资",
    filterCinematic: "电影级航拍",
    filterCommercial: "商业广告",
    filterSciFi: "未来科幻",
    filterAvatars: "数字人短剧",
    filterNature: "4K超清自然",
    playNow: "立即点播",
    forkToStudio: "复刻参数到 Studio",
    downloadMaster: "下载 4K 母带",
    copyStreamUrl: "复制 HLS 点播流",
    streamCopied: "点播流地址已复制 (https://vod.goldly.ai/...)",
    theaterMode: "剧场模式",
    normalMode: "标准模式",
    subtitlesOn: "AI 双语字幕",
    subtitlesOff: "关闭字幕",
    speed: "倍速",
    quality: "画质",
    fpsLabel: "帧率输出",
    codecLabel: "编码格式",
    motionLabel: "运镜动态幅度",
    soundtrackLabel: "同步生成电影级配乐",
    autoSubtitlesLabel: "AI 自动生成双语字幕",
    publishToVod: "发布至点播媒资库",
    publishedSuccess: "已成功发布至音视频点播媒资库，已自动启动自适应转码工作流！",
    ttfbMetric: "起播首帧耗时",
    rebufferingMetric: "播放卡顿率",
    cdnHitMetric: "边缘命中率",
    peakBandwidthMetric: "点播带宽峰值",
    totalPlaysMetric: "累计点播播放量",
    avgCompletionMetric: "平均完播率",
    analyticsTitle: "点播可观测性与遥测数据",
    analyticsSubtitle: "实时监测全球视频点播起播性能、卡顿率、码率占比与地域流量分布。",
    transcodingPipelines: "点播转码工作流",
    mediaSpecs: "媒资技术规格",
    hlsStream: "HLS 点播流 (m3u8)",
    mp4Cdn: "MP4 备用 CDN",
    edgeNode: "就近下发节点",
    viewsCount: "播放次数",
  },
  en: {
    brandConsole: "Console",
    services: "Services",
    searchPlaceholder: "Search capabilities, jobs, VOD assets, endpoints (Ctrl + K)",
    regionLabel: "ap-southeast-1 (Singapore Primary)",
    corporateSite: "Corporate Site",
    operational: "All Systems Operational",
    operationalStatus: "All Nodes Online",
    heroTitle: "Console Workspace Overview",
    heroDesc: "Centralized management of your VOD streaming media, AI creation pipelines, and API runtime resources.",
    openStudio: "Open AI Studio",
    exploreCatalog: "Explore Capabilities",
    exploreVod: "Explore VOD Streaming",
    manageKeys: "Manage API Keys",
    radarTitle: "Global Edge Telemetry",
    radarTelemetry: "Edge Telemetry",
    mtdSpend: "MTD Spend",
    budgetUsed: "Budget Utilized",
    clusterSlaMetric: "Sovereign Cluster SLA",
    clusterSlaVal: "99.99% SLA",
    clusterSlaSub: "8 edge compute nodes fully operational",
    vodAssetsMetric: "Curated VOD Assets",
    vodAssetsVal: "128 Titles",
    vodAssetsSub: "4K HEVC / AV1 Adaptive Transcoded",
    totalInvocations: "30D Plays & Invocations",
    vsLastMonth: "MoM Growth",
    vodBandwidthMetric: "Storage & Bandwidth",
    vodBandwidthSub: "Allocated media storage & egress",
    gatewayStatusMetric: "Gateway Status",
    gatewayStatusVal: "Ready / Operational",
    gatewayStatusSub: "All workers idle & ready",
    activeCaps: "Capabilities Ready",
    productionReady: "VOD & AI Ready",
    chartTitle: "VOD Throughput & Workloads (14 Days)",
    chartSubtitle: "Aggregated bandwidth, streaming plays, and API inference tokens",
    viewAnalytics: "View VOD Analytics",
    quickstartTitle: "Product-Grade VOD & Developer Integration",
    quickstartSubtitle: "Generate, transcode, upscale and stream AI video in 3 minutes",
    step1Title: "Create Production API Keys",
    step1Desc: "Issue scoped tokens for organization Goldly Labs",
    step2Title: "Prompt & Direct in AI Studio",
    step2Desc: "Test camera trajectory, temporal stability and parameters",
    step3Title: "Publish Directly to VOD Library",
    step3Desc: "Automatic H.265 / AV1 adaptive bitrate transcoding & upscaling",
    step4Title: "Stream via Web SDK & HLS",
    step4Desc: "Sub-200ms first frame playback with anti-leech DRM security",
    servicesDirectory: "Services Directory",
    recentJobsTitle: "Recent Jobs & Transcoding Pipelines",
    recentJobsSubtitle: "Active production transcoding, AI super-resolution and inference runs",
    viewAllJobs: "View All Pipelines",
    jobId: "Job Pipeline ID",
    capability: "Category",
    operation: "Pipeline Action",
    status: "Status",
    consumption: "Specs",
    latency: "Duration",
    dispatched: "Dispatched",
    estimatedCost: "Estimated Cost",
    actions: "Actions",
    details: "Details",
    studioTitle: "AI Creation Studio",
    studioPath: "AI Studio",
    tryPresets: "Try Presets:",
    systemPromptTitle: "System Directive & Safety Guardrails",
    systemPromptPlaceholder: "Configure AI role, business boundaries, negative constraints...",
    userPromptLabel: "Prompt & Scene Directing Instructions",
    charLimit: "Characters",
    aspectRatio: "Aspect Ratio",
    styleAesthetic: "Aesthetic Preset",
    sequenceDuration: "Duration",
    cameraDynamic: "Camera Dynamics",
    endpointLabel: "Endpoint",
    estSLA: "Est. Turnaround",
    clear: "Clear",
    runTask: "Run Generation Task",
    processing: "Rendering & Transcoding Video...",
    liveResult: "Real-time Live Result",
    rawJson: "JSON Contract",
    integrationCode: "Integration Code",
    copyOutput: "Copy Output",
    copyCode: "Copy Code",
    copied: "Copied to clipboard",
    profileTier: "Inference Tier",
    tierFast: "Fast Tier",
    tierFastDesc: "Ultra-low latency for interactive loops",
    tierBalanced: "Balanced Tier",
    tierBalancedDesc: "Enterprise recommendation: Quality + Speed",
    tierQuality: "Quality Tier",
    tierQualityDesc: "Deep reasoning & complex temporal choreography",
    temperature: "Temperature (Creativity)",
    maxTokens: "Max Tokens",
    streaming: "SSE Streaming",
    zeroRetention: "Zero Data Retention",
    zeroRetentionDesc: "Prompts and video source never used for public training",
    multiZoneFailover: "Multi-Zone Hot Standby",
    multiZoneFailoverDesc: "Sub-second failover and traffic rebalancing",
    catalogTitle: "Capabilities & Model Catalog",
    catalogDesc: "Full-modality AI capabilities & VOD streaming matrix with unified billing.",
    searchCatalog: "Search capabilities, transcode templates, endpoints...",
    standardsTitle: "Infrastructure Standard Commitments",
    allJobs: "All Jobs",
    running: "Running",
    succeeded: "Succeeded",
    failed: "Failed",
    exportCsv: "Export CSV",
    apiKeysTitle: "API Keys & Playback Tokens",
    apiKeysDesc: "Manage production tokens, playback credentials, and DRM anti-leech keys.",
    createKey: "Create New Key",
    keySecurityTip: "VOD Security Best Practice",
    usageTitle: "Resource Usage & Quotas",
    usageDesc: "Monitor GPU compute hours, VOD streaming egress, persistent storage, and API concurrency limits.",
    requestQuota: "Request Quota Increase",
    exportUsage: "Export Usage Telemetry",
    billingNav: "Billing & Invoices",
    financeNav: "Ledger & Top-up",
    billingTitle: "Billing & Cost Management",
    billingDesc: "Manage enterprise billing, daily expenditure breakdown, invoices and budget limits.",
    financeTitle: "Finance Ledger & Balance Top-up",
    financeDesc: "Enterprise cash ledger, transaction history, bank wire recharge and tax profile management.",
    downloadInvoice: "Download Invoice",
    editBudget: "Edit Budget",
    logsTitle: "Observability & Distributed Tracing",
    logsDesc: "Sub-millisecond tracing across edge nodes and first-frame playback tracking.",
    liveTail: "Live Tail",
    securityTitle: "Security & DRM Guard",
    securityDesc: "Role-based access (RBAC), HLS 128-bit AES encryption, and domain whitelisting.",
    inviteMember: "Invite Member",
    environment: "Environment",
    production: "Production (Primary)",
    staging: "Staging (Pre-release)",
    development: "Development (Sandbox)",
    projectContext: "PROJECT CONTEXT",
    prodApps: "Production Apps",

    // VOD specific keys
    vodTitle: "VOD Media & Intelligent Asset Library",
    vodSubtitle: "Product-grade end-to-end VOD streaming: AI video generation, adaptive bitrate transcoding (H.265/AV1), AI upscaling, and low-latency edge delivery.",
    filterAll: "All Media",
    filterCinematic: "Cinematic Aerial",
    filterCommercial: "Commercials",
    filterSciFi: "Sci-Fi VFX",
    filterAvatars: "Digital Humans",
    filterNature: "4K Nature",
    playNow: "Play Now",
    forkToStudio: "Fork to Studio",
    downloadMaster: "Download 4K Master",
    copyStreamUrl: "Copy HLS Stream",
    streamCopied: "HLS Stream URL copied (https://vod.goldly.ai/...)",
    theaterMode: "Theater Mode",
    normalMode: "Standard Mode",
    subtitlesOn: "AI Subtitles",
    subtitlesOff: "Subtitles Off",
    speed: "Speed",
    quality: "Quality",
    fpsLabel: "Target FPS",
    codecLabel: "Target Codec",
    motionLabel: "Motion Dynamic Amplitude",
    soundtrackLabel: "Include Cinematic Audio Track",
    autoSubtitlesLabel: "AI Generate Multilingual Subtitles",
    publishToVod: "Publish to VOD Library",
    publishedSuccess: "Successfully published to VOD Media Library! Adaptive transcode pipeline triggered.",
    ttfbMetric: "First Frame (TTFB)",
    rebufferingMetric: "Rebuffering Rate",
    cdnHitMetric: "Edge Cache Hit",
    peakBandwidthMetric: "Peak Bandwidth",
    totalPlaysMetric: "Total VOD Plays",
    avgCompletionMetric: "Avg. Completion",
    analyticsTitle: "VOD Observability & Telemetry",
    analyticsSubtitle: "Real-time metrics on first-frame latency, rebuffering, bitrate split, and edge geography.",
    transcodingPipelines: "Transcode Workflows",
    mediaSpecs: "Technical Specifications",
    hlsStream: "HLS Stream (m3u8)",
    mp4Cdn: "MP4 Backup CDN",
    edgeNode: "Nearest Edge Node",
    viewsCount: "Plays",
  },
};

// --- Rich Curated VOD Media Library (Real Playable Media Assets) ---
const vodMediaLibrary = [
  {
    id: "vod_9a2f45",
    title: "未来都市与穿梭悬浮车 (Neo-Tokyo Cyber Expressway 4K)",
    category: "scifi",
    durationSec: 15,
    durationText: "00:15",
    resolution: "4K UHD (3840x2160)",
    fps: "60 fps",
    codec: "H.265 / HEVC Main 10",
    bitrate: "18.4 Mbps",
    audio: "Dolby Atmos 5.1 / 320 kbps",
    videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    poster: vodPosterTokyo,
    views: "142,500",
    likes: "8,920",
    prompt: "电影级穿越机穿梭于霓虹未来科技都市，高架智驾车流光影轨迹，4K 60fps，体积丁达尔雾效与湿漉路面反光。",
    cameraMotion: "高速穿梭机 (FPV Drone)",
    aspectRatio: "16:9",
    seed: "84920194",
    status: "Transcoded",
    subtitleZh: "正在接入新加坡核心算力集群，时序生成渲染率 60.00 FPS。",
    subtitleEn: "Ingesting Singapore sovereign edge cluster, temporal render 60.00 FPS.",
  },
  {
    id: "vod_9a2f46",
    title: "晨曦金光掠过阿尔卑斯雪山 (Golden Hour Alpine Peaks 4K)",
    category: "cinematic",
    durationSec: 15,
    durationText: "00:15",
    resolution: "4K UHD (3840x2160)",
    fps: "60 fps",
    codec: "H.265 / HEVC Main 10",
    bitrate: "20.1 Mbps",
    audio: "Cinematic Orchestral / 24-bit",
    videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    poster: "img/portfolio/02-large.jpg",
    views: "98,200",
    likes: "6,410",
    prompt: "日出时分高空俯瞰阿尔卑斯积雪山脉，金色晨曦染透云海边缘，缓慢推镜头，大师级自然风光航拍。",
    cameraMotion: "平滑推近 (Pan & Zoom)",
    aspectRatio: "16:9",
    seed: "47192083",
    status: "Transcoded",
    subtitleZh: "晨曦光影穿透积雪岩层，高动态范围 HDR10 映射就绪。",
    subtitleEn: "Golden sunlight penetrating snow peaks, HDR10 tone-mapped.",
  },
  {
    id: "vod_9a2f47",
    title: "商业智能跑车流体光影广告 (Electric Hypercar Commercial Launch)",
    category: "commercial",
    durationSec: 12,
    durationText: "00:12",
    resolution: "4K UHD (3840x2160)",
    fps: "60 fps",
    codec: "Apple ProRes 422 / H.265",
    bitrate: "24.5 Mbps",
    audio: "Dolby Digital Plus / 48kHz",
    videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
    poster: "img/portfolio/03-large.jpg",
    views: "215,400",
    likes: "14,800",
    prompt: "极简深邃暗调影棚内展示概念电动超跑，流动光斑勾勒空气动力学碳纤维车身，商业级影视质感广告片。",
    cameraMotion: "环绕运镜 (Orbit)",
    aspectRatio: "16:9",
    seed: "31829401",
    status: "Transcoded",
    subtitleZh: "高动态范围商业级广告质感，空气动力学微观反射计算。",
    subtitleEn: "High dynamic range commercial grade, aerodynamic reflection rendered.",
  },
  {
    id: "vod_9a2f48",
    title: "AI 双语数字人全球峰会致辞 (Autonomous AI Anchor Keynote)",
    category: "avatars",
    durationSec: 15,
    durationText: "00:15",
    resolution: "1080P FHD (1920x1080)",
    fps: "60 fps",
    codec: "AV1 Next-Gen / H.264",
    bitrate: "8.2 Mbps",
    audio: "Studio Vocal Isolated / 48kHz",
    videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyBlazes.mp4",
    poster: "img/portfolio/04-large.jpg",
    views: "64,800",
    likes: "4,120",
    prompt: "高保真 AI 数字人播报员在国际科技峰会主舞台致辞，微表情生动真实，面部肌肉与声学波形完美同步。",
    cameraMotion: "固定机位 (Static)",
    aspectRatio: "16:9",
    seed: "19284019",
    status: "Transcoded",
    subtitleZh: "全球 AI 智能网关峰会正式启动，欢迎来自亚太与欧洲的参会嘉宾。",
    subtitleEn: "Global AI Gateway Summit inaugurated. Welcome international attendees.",
  },
  {
    id: "vod_9a2f49",
    title: "深海发光水母生态微距 (Bioluminescent Abyssal Jellyfish 4K)",
    category: "nature",
    durationSec: 15,
    durationText: "00:15",
    resolution: "4K UHD (3840x2160)",
    fps: "60 fps",
    codec: "H.265 / HEVC Main 10",
    bitrate: "17.8 Mbps",
    audio: "Underwater Sub-bass Acoustics",
    videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
    poster: "img/portfolio/05-large.jpg",
    views: "119,300",
    likes: "7,850",
    prompt: "深海大洋漆黑水体中慢速律动的发光水母，半透明伞状边缘散发梦幻蓝绿荧光粒子，微距写实纪录片摄影。",
    cameraMotion: "平滑推近 (Pan & Zoom)",
    aspectRatio: "16:9",
    seed: "58291049",
    status: "Transcoded",
    subtitleZh: "深海微观浮游生态漫游，极低照度弱光降噪自适应滤波。",
    subtitleEn: "Deep sea pelagic micro-ecosystem, adaptive low-light filtering.",
  },
  {
    id: "vod_9a2f50",
    title: "微观神经元能量突触脉冲 (Quantum Core & Neural Synapse 4K)",
    category: "scifi",
    durationSec: 14,
    durationText: "00:14",
    resolution: "4K UHD (3840x2160)",
    fps: "60 fps",
    codec: "H.265 / HEVC Main 10",
    bitrate: "21.2 Mbps",
    audio: "Sci-Fi Sub-bass Resonance",
    videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
    poster: "img/portfolio/08-large.jpg",
    views: "93,100",
    likes: "5,980",
    prompt: "微观量子神经元节点突触之间电信号脉冲传递，流体能量粒子在三维网格中流动，慢速环绕镜头。",
    cameraMotion: "环绕运镜 (Orbit)",
    aspectRatio: "16:9",
    seed: "67192048",
    status: "Transcoded",
    subtitleZh: "神经元突触电信号传递完成，全链路时延 142 ms。",
    subtitleEn: "Synaptic action potential delivered, end-to-end latency 142 ms.",
  },
];

// --- Product-Grade Interactive VOD Player Component ---
const VodPlayer = ({ media, lang, onForkToStudio, onShowToast }) => {
  const t = i18n[lang];
  const videoRef = useRef(null);
  const containerRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(media.durationSec || 15);
  const [volume, setVolume] = useState(0.85);
  const [isMuted, setIsMuted] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1.0);
  const [quality, setQuality] = useState("4K");
  const [showSubtitles, setShowSubtitles] = useState(true);
  const [isTheaterMode, setIsTheaterMode] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isBuffering, setIsBuffering] = useState(false);
  const [showControls, setShowControls] = useState(true);
  const controlsTimeoutRef = useRef(null);

  // Format seconds to mm:ss
  const formatTime = (secs) => {
    if (isNaN(secs) || secs < 0) return "00:00";
    const m = Math.floor(secs / 60);
    const s = Math.floor(secs % 60);
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    // Reset video state when media changes
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      setCurrentTime(0);
      setIsPlaying(false);
      videoRef.current.pause();
    }
  }, [media.id]);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch(() => {
        setIsPlaying(true);
      });
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
      if (videoRef.current.duration && !isNaN(videoRef.current.duration)) {
        setDuration(videoRef.current.duration);
      }
    }
  };

  const handleSeek = (e) => {
    const targetTime = parseFloat(e.target.value);
    setCurrentTime(targetTime);
    if (videoRef.current) {
      videoRef.current.currentTime = targetTime;
    }
  };

  const handleVolumeChange = (e) => {
    const newVol = parseFloat(e.target.value);
    setVolume(newVol);
    setIsMuted(newVol === 0);
    if (videoRef.current) {
      videoRef.current.volume = newVol;
      videoRef.current.muted = newVol === 0;
    }
  };

  const toggleMute = () => {
    if (!videoRef.current) return;
    if (isMuted) {
      videoRef.current.muted = false;
      setIsMuted(false);
      videoRef.current.volume = volume > 0 ? volume : 0.85;
    } else {
      videoRef.current.muted = true;
      setIsMuted(true);
    }
  };

  const changeSpeed = (rate) => {
    setPlaybackRate(rate);
    if (videoRef.current) {
      videoRef.current.playbackRate = rate;
    }
    onShowToast?.(lang === "zh" ? `已切换为 ${rate}x 倍速播放` : `Playback speed: ${rate}x`);
  };

  const changeQuality = (q) => {
    setQuality(q);
    onShowToast?.(
      lang === "zh" 
        ? `正在平滑无缝切换至 ${q} 超清流 (自适应缓冲已就绪)` 
        : `Switching to ${q} stream (Adaptive buffer synchronized)`
    );
  };

  const toggleFullscreen = () => {
    if (!containerRef.current) return;
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen?.().then(() => {
        setIsFullscreen(true);
      }).catch(() => {
        setIsFullscreen(true);
      });
    } else {
      document.exitFullscreen?.().then(() => {
        setIsFullscreen(false);
      });
    }
  };

  const handleMouseMove = () => {
    setShowControls(true);
    if (controlsTimeoutRef.current) clearTimeout(controlsTimeoutRef.current);
    controlsTimeoutRef.current = setTimeout(() => {
      if (isPlaying) setShowControls(false);
    }, 3500);
  };

  const progressPercent = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div 
      ref={containerRef} 
      className={`gc-vod-player-wrapper ${isTheaterMode ? "theater-mode" : ""} ${isFullscreen ? "fullscreen" : ""}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={() => isPlaying && setShowControls(false)}
    >
      {/* Main Video Viewport */}
      <div className="gc-vod-viewport" onClick={togglePlay}>
        <video
          ref={videoRef}
          src={media.videoUrl}
          poster={media.poster}
          playsInline
          onTimeUpdate={handleTimeUpdate}
          onWaiting={() => setIsBuffering(true)}
          onPlaying={() => setIsBuffering(false)}
          onEnded={() => setIsPlaying(false)}
          className="gc-vod-video-element"
        />

        {/* Top Floating Watermark / Header */}
        <div className={`gc-vod-top-overlay ${showControls ? "visible" : "hidden"}`}>
          <div className="gc-vod-branding">
            <span className="gc-vod-brand-pill">GOLDLY VOD</span>
            <span className="gc-vod-title-text">{media.title}</span>
          </div>
          <div className="gc-vod-top-badges">
            <span className="gc-vod-badge-tag live-badge">4K 60FPS</span>
            <span className="gc-vod-badge-tag">{media.codec}</span>
            <span className="gc-vod-badge-tag">{media.audio}</span>
          </div>
        </div>

        {/* AI Real-time Subtitles (随时间轴双语呈现) */}
        {showSubtitles && (
          <div className="gc-vod-subtitles-container" onClick={(e) => e.stopPropagation()}>
            <div className="gc-vod-subtitle-pill">
              <span className="gc-vod-sub-zh">{media.subtitleZh}</span>
              <span className="gc-vod-sub-en">{media.subtitleEn}</span>
            </div>
          </div>
        )}

        {/* Big Center Play/Buffering Icon */}
        {!isPlaying && (
          <div className="gc-vod-center-action" onClick={(e) => { e.stopPropagation(); togglePlay(); }}>
            <div className="gc-vod-big-play-btn">
              <Icon name="play" size={28} />
            </div>
          </div>
        )}

        {isBuffering && (
          <div className="gc-vod-buffering-overlay">
            <span className="gc-spinner large"></span>
            <span>{lang === "zh" ? "自适应流缓冲中..." : "Buffering stream..."}</span>
          </div>
        )}
      </div>

      {/* Professional Player Controls Bar */}
      <div className={`gc-vod-controls-bar ${showControls || !isPlaying ? "visible" : "hidden"}`}>
        {/* Progress Slider (Scrubber) */}
        <div className="gc-vod-progress-row">
          <input
            type="range"
            min="0"
            max={duration || 100}
            step="0.05"
            value={currentTime}
            onChange={handleSeek}
            className="gc-vod-scrubber"
            style={{
              background: `linear-gradient(to right, #2563eb ${progressPercent}%, rgba(255,255,255,0.2) ${progressPercent}%)`
            }}
          />
        </div>

        {/* Button Controls Row */}
        <div className="gc-vod-buttons-row">
          <div className="gc-vod-ctrl-left">
            {/* Play/Pause */}
            <button type="button" className="gc-vod-ctrl-btn" onClick={togglePlay} title={isPlaying ? "暂停" : "播放"}>
              <Icon name={isPlaying ? "pause" : "play"} size={16} />
            </button>

            {/* Volume */}
            <div className="gc-vod-volume-group">
              <button type="button" className="gc-vod-ctrl-btn" onClick={toggleMute}>
                <Icon name={isMuted || volume === 0 ? "volumeX" : "volume"} size={16} />
              </button>
              <input
                type="range"
                min="0"
                max="1"
                step="0.05"
                value={isMuted ? 0 : volume}
                onChange={handleVolumeChange}
                className="gc-vod-volume-slider"
              />
            </div>

            {/* Timecode */}
            <div className="gc-vod-timecode">
              <span className="gc-vod-time-current">{formatTime(currentTime)}</span>
              <span className="gc-vod-time-sep">/</span>
              <span className="gc-vod-time-duration">{formatTime(duration)}</span>
            </div>
          </div>

          <div className="gc-vod-ctrl-right">
            {/* Speed Selector */}
            <div className="gc-vod-dropdown-wrap">
              <button type="button" className="gc-vod-text-btn">
                <span>{playbackRate === 1.0 ? t.speed : `${playbackRate}x`}</span>
              </button>
              <div className="gc-vod-dropdown-menu">
                {[0.5, 0.75, 1.0, 1.25, 1.5, 2.0].map((rate) => (
                  <button
                    key={rate}
                    type="button"
                    className={`gc-vod-dropdown-item ${playbackRate === rate ? "active" : ""}`}
                    onClick={() => changeSpeed(rate)}
                  >
                    {rate}x
                  </button>
                ))}
              </div>
            </div>

            {/* Quality Selector */}
            <div className="gc-vod-dropdown-wrap">
              <button type="button" className="gc-vod-text-btn quality-btn">
                <span>{quality}</span>
              </button>
              <div className="gc-vod-dropdown-menu">
                {["4K", "1080P", "720P", "Auto"].map((q) => (
                  <button
                    key={q}
                    type="button"
                    className={`gc-vod-dropdown-item ${quality === q ? "active" : ""}`}
                    onClick={() => changeQuality(q)}
                  >
                    {q === "4K" ? "4K 60FPS (HDR)" : q === "Auto" ? "自适应码率 (HLS)" : `${q} 超清`}
                  </button>
                ))}
              </div>
            </div>

            {/* Subtitle Toggle */}
            <button
              type="button"
              className={`gc-vod-ctrl-btn ${showSubtitles ? "active" : ""}`}
              onClick={() => setShowSubtitles(!showSubtitles)}
              title={showSubtitles ? t.subtitlesOff : t.subtitlesOn}
            >
              <Icon name="subtitles" size={16} />
            </button>

            {/* Theater Mode */}
            <button
              type="button"
              className={`gc-vod-ctrl-btn ${isTheaterMode ? "active" : ""}`}
              onClick={() => setIsTheaterMode(!isTheaterMode)}
              title={t.theaterMode}
            >
              <Icon name="theater" size={16} />
            </button>

            {/* Fullscreen */}
            <button
              type="button"
              className="gc-vod-ctrl-btn"
              onClick={toggleFullscreen}
              title={isFullscreen ? t.exitFullscreen : t.fullscreen}
            >
              <Icon name={isFullscreen ? "minimize" : "maximize"} size={16} />
            </button>
          </div>
        </div>
      </div>

      {/* Media Technical Specs & Actions Bar */}
      <div className="gc-vod-meta-bar">
        <div className="gc-vod-specs-grid">
          <div className="gc-vod-spec-item">
            <span className="gc-vod-spec-label">{t.fpsLabel}</span>
            <span className="gc-vod-spec-val">{media.fps}</span>
          </div>
          <div className="gc-vod-spec-item">
            <span className="gc-vod-spec-label">{t.codecLabel}</span>
            <span className="gc-vod-spec-val">{media.codec}</span>
          </div>
          <div className="gc-vod-spec-item">
            <span className="gc-vod-spec-label">Bitrate</span>
            <span className="gc-vod-spec-val">{media.bitrate}</span>
          </div>
          <div className="gc-vod-spec-item">
            <span className="gc-vod-spec-label">{t.p99Latency}</span>
            <span className="gc-vod-spec-val highlight-green">142 ms</span>
          </div>
          <div className="gc-vod-spec-item">
            <span className="gc-vod-spec-label">{t.edgeNode}</span>
            <span className="gc-vod-spec-val">SG-Edge-01 (100% Hit)</span>
          </div>
        </div>

        <div className="gc-vod-action-row">
          <div className="gc-vod-stream-links">
            <span className="gc-vod-stream-title">{t.hlsStream}:</span>
            <code className="gc-vod-stream-url">https://vod.goldly.ai/v1/live/{media.id}.m3u8</code>
          </div>
          <div className="gc-vod-action-btns">
            <button
              type="button"
              className="gc-btn gc-btn-secondary gc-btn-sm"
              onClick={() => {
                navigator.clipboard?.writeText(`https://vod.goldly.ai/v1/live/${media.id}.m3u8`);
                onShowToast?.(t.streamCopied);
              }}
            >
              <Icon name="copy" size={13} />
              {t.copyStreamUrl}
            </button>
            <button
              type="button"
              className="gc-btn gc-btn-primary gc-btn-sm"
              onClick={() => onForkToStudio?.(media)}
            >
              <Icon name="studio" size={13} />
              {t.forkToStudio}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- Capability Registry ---
const getCapabilities = (lang) => [
  {
    id: "text",
    code: "TX",
    badge: lang === "zh" ? "大模型与推理" : "LLM & Reasoning",
    name: lang === "zh" ? "AI 文本与复杂推理" : "AI Text & Reasoning",
    headline: lang === "zh" ? "企业级多模态对话、代码编写与结构化数据提取" : "Enterprise Multi-modal Chat, Code & Structured Synthesis",
    description: lang === "zh" 
      ? "生产级推理分析、思维链推导、复杂代码生成与结构化 JSON 输出，均通过统一标准 API 提供。"
      : "Production reasoning, chain-of-thought analysis, code generation and structured JSON extraction via a single unified API.",
    endpoint: "/v1/text/generate",
    unit: lang === "zh" ? "千 Token (1K)" : "1K tokens",
    latency: "280 ms",
    accent: "violet",
    status: lang === "zh" ? "运行正常" : "Operational",
    features: lang === "zh" 
      ? ["SSE 流式传输", "结构化 JSON 模式", "函数与工具调用", "128K 超长上下文", "确定性种子"]
      : ["Streaming SSE", "Structured JSON Mode", "Function / Tool Use", "128K Context Window", "Deterministic Seed"],
    samplePrompts: [
      {
        title: lang === "zh" ? "宏观半导体市场研报" : "Financial Market Synthesis",
        prompt: lang === "zh" 
          ? "请深度分析 2026 年亚太半导体出口配额对跨国供应链的宏观影响，给出 3 个核心风险敞口，并以 Markdown 表格输出对冲执行策略。"
          : "Analyze the macroeconomic impact of APAC semiconductor export quotas for Q3 2026. Provide 3 core risk vectors and an executive summary table in markdown.",
      },
      {
        title: lang === "zh" ? "企业级意图与 JSON 提取" : "Enterprise JSON Extraction",
        prompt: lang === "zh"
          ? "从这段客户服务日志中提取意图、情感评分 (0.0-1.0)、紧急度及行动项：'我们昨天监测到新加坡网关有 15% 的延迟毛刺，请在欧洲盘 08:00 UTC 开市前完成排查。'"
          : "Extract customer intent, sentiment score (0.0 to 1.0), urgency level, and action items from: 'We noticed a 15% latency increase on Singapore endpoints yesterday. Please investigate before our European market open at 08:00 UTC.'",
      },
      {
        title: lang === "zh" ? "异步重试 Python SDK 封装" : "Python SDK Integration Script",
        prompt: lang === "zh"
          ? "为 GOLDLY AI 文本接口 /v1/text/generate 编写一个支持指数退避与自动重试的高性能异步 Python 客户端类。"
          : "Write an async Python wrapper with automatic retries and exponential backoff for the GOLDLY AI Text API endpoint /v1/text/generate.",
      },
    ],
  },
  {
    id: "image",
    code: "IM",
    badge: lang === "zh" ? "视觉资产生成" : "Visual Synthesis",
    name: lang === "zh" ? "AI 图像与视觉资产工坊" : "AI Image & Asset Studio",
    headline: lang === "zh" ? "高保真商业级摄影、设计素材与品牌风格一致性" : "High-Fidelity Photorealism & Consistent Production Art",
    description: lang === "zh"
      ? "生成、精修、超分放大与重绘生产级视觉素材，具备严密的品牌安全护栏与画质标准。"
      : "Generate, edit, upscale and restyle production-ready visual assets with deterministic controls and brand-safe guardrails.",
    endpoint: "/v1/images/generations",
    unit: lang === "zh" ? "单张图像" : "image",
    latency: "2.4 s",
    accent: "cyan",
    status: lang === "zh" ? "运行正常" : "Operational",
    features: lang === "zh"
      ? ["4K 高清资产放大", "像素级比例约束", "负向提示词过滤", "专业影棚布光", "品牌色板锁相"]
      : ["4K Asset Upscaling", "Exact Aspect Ratios", "Negative Prompting", "Lighting Presets", "Brand Palette Lock"],
    samplePrompts: [
      {
        title: lang === "zh" ? "赛博朋克新加坡天际线" : "Cyberpunk Singapore Skyline",
        prompt: lang === "zh"
          ? "黄昏时分超高清未来主义新加坡滨海湾天际线，水面霓虹倒影，电影级体积丁达尔光雾，8k 分辨率，写实建筑渲染。"
          : "Ultra-detailed futuristic Singapore Marina Bay skyline at dusk, neon reflections on water, cinematic volumetric fog, 8k resolution, photorealistic architectural rendering.",
      },
      {
        title: lang === "zh" ? "极简 3D 数据面板" : "Minimalist SaaS Product UI",
        prompt: lang === "zh"
          ? "高质感极简 3D 毛玻璃仪表板卡片，呈现毫秒级网络延迟遥测图表，柔和影棚漫反射布光，石墨黑与钴蓝调。"
          : "Clean minimal 3D glassmorphic dashboard widget showing network latency telemetry, soft studio ambient lighting, premium graphite and cobalt palette.",
      },
      {
        title: lang === "zh" ? "金属几何品牌雕塑" : "Editorial Brand Mascot",
        prompt: lang === "zh"
          ? "深色大理石展台上陈列的流线型金属几何猎鹰艺术雕像，戏剧性聚光灯打光，微距写实商业静物摄影。"
          : "Sleek metallic geometric falcon sculpture on a dark marble pedestal, dramatic studio spotlighting, hyperrealistic macro photography.",
      },
    ],
  },
  {
    id: "video",
    code: "VI",
    badge: lang === "zh" ? "时序视频与点播引擎" : "Temporal VOD Engine",
    name: lang === "zh" ? "AI 动态视频与点播合成" : "AI Video & VOD Synthesis",
    headline: lang === "zh" ? "时序平滑运动控制、60FPS 高帧率与自适应点播切片" : "Temporal Generative Motion, 60fps & Adaptive VOD Transcoding",
    description: lang === "zh"
      ? "通过异步流式任务合成、延展并精密调度电影级动态视频，并一键推流至点播媒资库进行自适应转码。"
      : "Synthesize, extend, choreograph cinematic videos, and seamlessly stream directly into the VOD library for HLS adaptive delivery.",
    endpoint: "/v1/videos/generations",
    unit: lang === "zh" ? "输出秒数" : "output sec",
    latency: "16.8 s",
    accent: "amber",
    status: lang === "zh" ? "运行正常" : "Operational",
    features: lang === "zh"
      ? ["4K 60FPS 电影级画质", "动态镜头推拉摇移", "运动强度物理引导", "自适应多码率 HLS 切片", "无缝发布至点播库"]
      : ["4K 60fps Master", "Dynamic Camera Pan/Zoom", "Prompt Motion Dynamics", "HLS ABR Transcoding", "1-Click Publish to VOD"],
    samplePrompts: [
      {
        title: lang === "zh" ? "高科技数据中心 FPV 穿梭" : "Cinematic Drone FPV Shot",
        prompt: lang === "zh"
          ? "流畅电影级穿越机穿梭于现代化算力机房走廊，光纤脉冲微光闪烁，慢镜头后拉升镜，4k 60fps 质感。"
          : "Smooth cinematic drone shot flying through a high-tech datacenter corridor, pulsing fiber optic lights, slow motion camera pull-back, 4k 60fps style.",
      },
      {
        title: lang === "zh" ? "微观神经网络脉冲" : "Microscopic Synaptic Pulse",
        prompt: lang === "zh"
          ? "微观视角下发光神经突触节点传递电信号脉冲，粒子流体动效，深黑背景，平滑慢速环绕运镜。"
          : "Macro view of luminous neural network nodes pulsing with electrical energy, fluid particle transitions, deep obsidian background, slow smooth orbit.",
      },
      {
        title: lang === "zh" ? "摩天大楼晨曦延时" : "Architectural Golden Hour",
        prompt: lang === "zh"
          ? "日出时分摩天大楼玻璃幕墙延时摄影，云海倒映于镀膜玻璃，优雅缓慢仰角上移。"
          : "Time-lapse of sunrise over a glass skyscraper complex, reflection of clouds across tinted panels, elegant slow upward pan.",
      },
    ],
  },
];

const getNavGroups = (lang) => [
  {
    label: lang === "zh" ? "核心服务与点播 (SERVICES)" : "SERVICES & STREAMING",
    items: [
      { id: "overview", label: lang === "zh" ? "控制台总览" : "Console Overview", icon: "overview" },
      { id: "vod", label: lang === "zh" ? "音视频点播与媒资" : "VOD Media & Streaming", icon: "vod", badge: "PRO" },
      { id: "studio", label: lang === "zh" ? "AI 创作与生成工坊" : "AI Creation Studio", icon: "studio" },
      { id: "capabilities", label: lang === "zh" ? "能力产品目录" : "Capability Catalog", icon: "catalog" },
      { id: "jobs", label: lang === "zh" ? "流水线与转码任务" : "Pipelines & Transcoding", icon: "jobs" },
    ],
  },
  {
    label: lang === "zh" ? "分发与观测 (OBSERVABILITY)" : "DISTRIBUTION & ANALYTICS",
    items: [
      { id: "analytics", label: lang === "zh" ? "点播与调用数据分析" : "VOD Analytics & Telemetry", icon: "analytics" },
      { id: "logs", label: lang === "zh" ? "边缘链路日志与追踪" : "Observability Logs", icon: "logs" },
    ],
  },
  {
    label: lang === "zh" ? "开发者与治理 (GOVERNANCE)" : "DEVELOPER & GOVERNANCE",
    items: [
      { id: "keys", label: lang === "zh" ? "API 访问与播放凭证" : "API & Playback Keys", icon: "keys" },
      { id: "usage", label: lang === "zh" ? "资源用量与配额监控" : "Usage & Quotas", icon: "usage" },
      { id: "security", label: lang === "zh" ? "访问控制与防盗链" : "Security & DRM Guard", icon: "security" },
    ],
  },
  {
    label: lang === "zh" ? "财务计费与记账 (BILLING & FINANCE)" : "BILLING & FINANCE",
    items: [
      { id: "billing", label: lang === "zh" ? "费用总览与账单" : "Billing & Invoices", icon: "billing" },
      { id: "finance", label: lang === "zh" ? "财务记账与充值" : "Ledger & Top-up", icon: "finance" },
    ],
  },
];

const mockRecentJobs = [
  { id: "job_VOD_9981", capability: "VOD Transcode", action: "4K UHD H.265 自适应切片转码", status: "Succeeded", usage: "3840x2160 @ 60fps", duration: "12.8 s", time: "Just now", cost: "$0.0280" },
  { id: "job_VOD_9974", capability: "AI Enhance", action: "AI 超分修复与 60FPS 运动插帧", status: "Succeeded", usage: "Frame Interpolation", duration: "18.4 s", time: "8 min ago", cost: "$0.0540" },
  { id: "job_9A2K71", capability: "AI Text", action: "Structured reasoning", status: "Succeeded", usage: "4.8K tokens", duration: "1.24 s", time: "15 min ago", cost: "$0.0019" },
  { id: "job_VOD_9962", capability: "AI Subtitles", action: "语音识别生成双语字幕 (ASR)", status: "Succeeded", usage: "2 tracks (ZH/EN)", duration: "4.1 s", time: "12 min ago", cost: "$0.0080" },
  { id: "job_9A1X88", capability: "AI Image", action: "Photoreal 16:9 HD", status: "Succeeded", usage: "1 image", duration: "2.18 s", time: "24 min ago", cost: "$0.0240" },
  { id: "job_VOD_9950", capability: "DRM Pack", action: "HLS 128-bit AES 动态加密打包", status: "Succeeded", usage: "AES Encrypted", duration: "1.9 s", time: "45 min ago", cost: "$0.0040" },
];

const mockLogs = [
  { time: "04:12:08.412", method: "GET", endpoint: "/v1/live/vod_9a2f45.m3u8", status: "200", latency: "18 ms", id: "req_vod_8k4m", tokens: "HLS Slice", ip: "13.214.63.3" },
  { time: "04:11:42.108", method: "POST", endpoint: "/v1/vod/media/transcode", status: "202", latency: "142 ms", id: "req_vod_8j2z", tokens: "4K Pipeline", ip: "13.214.63.3" },
  { time: "04:10:14.180", method: "POST", endpoint: "/v1/videos/generations", status: "200", latency: "16,420 ms", id: "req_019f_7w2a", tokens: "60fps Video", ip: "13.214.63.3" },
  { time: "04:08:52.094", method: "GET", endpoint: "/v1/jobs/job_VOD_9981", status: "200", latency: "38 ms", id: "req_019f_6p9z", tokens: "—", ip: "13.214.63.3" },
  { time: "04:02:18.771", method: "POST", endpoint: "/v1/images/generations", status: "200", latency: "2,180 ms", id: "req_019f_5c1e", tokens: "1 img", ip: "13.214.63.3" },
  { time: "03:54:33.620", method: "POST", endpoint: "/v1/text/generate", status: "200", latency: "940 ms", id: "req_019f_4b7x", tokens: "2.1K", ip: "13.214.63.3" },
];

const usageTrendData = [
  { day: "Aug 25", requests: 1240, bandwidth: 4.2 },
  { day: "Aug 26", requests: 1520, bandwidth: 5.3 },
  { day: "Aug 27", requests: 1410, bandwidth: 4.9 },
  { day: "Aug 28", requests: 1890, bandwidth: 6.8 },
  { day: "Aug 29", requests: 1750, bandwidth: 6.2 },
  { day: "Aug 30", requests: 2100, bandwidth: 7.9 },
  { day: "Aug 31", requests: 1980, bandwidth: 7.4 },
  { day: "Sep 01", requests: 2340, bandwidth: 8.9 },
  { day: "Sep 02", requests: 2190, bandwidth: 8.4 },
  { day: "Sep 03", requests: 2560, bandwidth: 9.7 },
  { day: "Sep 04", requests: 2420, bandwidth: 9.1 },
  { day: "Sep 05", requests: 2780, bandwidth: 10.8 },
  { day: "Sep 06", requests: 2650, bandwidth: 10.2 },
  { day: "Today", requests: 2940, bandwidth: 12.4 },
];

const mockProductCosts = [
  {
    service: "AI 视频时序生成与超分 (AI Video Studio)",
    serviceEn: "AI Video Generation & Super-Res",
    unit: "秒 (4K 60FPS 时序渲染)",
    unitEn: "Seconds (4K 60FPS Temporal)",
    usage: "1,420 秒",
    unitPrice: "$0.400 / 秒",
    amount: "$568.00",
    percentage: 45.5,
  },
  {
    service: "音视频点播与 CDN 分发 (VOD Streaming)",
    serviceEn: "VOD CDN Egress & Transcoding",
    unit: "GB 出网流量 + 4K HLS 切片",
    unitEn: "GB Egress + 4K HLS Slice",
    usage: "24.8 TB",
    unitPrice: "$0.015 / GB",
    amount: "$372.00",
    percentage: 29.8,
  },
  {
    service: "LLM 混合推理与结构化解析 (LLM Inference)",
    serviceEn: "LLM Reasoning & Structured Parser",
    unit: "1M Tokens (混合推理)",
    unitEn: "1M Tokens (Hybrid Reasoning)",
    usage: "48.2 M Tokens",
    unitPrice: "$5.00 / 1M",
    amount: "$241.00",
    percentage: 19.3,
  },
  {
    service: "安全加密与 DRM 防盗链 (DRM Guard)",
    serviceEn: "DRM Security & Anti-Leech Guard",
    unit: "百万次动态 AES 密钥验签",
    unitEn: "1M AES DRM Verifications",
    usage: "17.0 M 次验签",
    unitPrice: "$4.00 / 1M",
    amount: "$68.00",
    percentage: 5.4,
  },
];

const mockMonthlyInvoices = [
  {
    cycle: "2026-03 (实时计费中)",
    cycleEn: "2026-03 (Current Billing)",
    id: "BILL-202603-998",
    mode: "按量后付费 (Postpaid)",
    gross: "$1,248.60",
    discount: "-$124.80",
    net: "$1,123.80",
    status: "计费中 (Accruing)",
    statusEn: "Accruing",
    doc: "消费明细预览 (CSV)",
    docEn: "Preview CSV",
  },
  {
    cycle: "2026-02",
    cycleEn: "2026-02",
    id: "BILL-202602-841",
    mode: "按量后付费 (Postpaid)",
    gross: "$3,892.40",
    discount: "-$389.20",
    net: "$3,503.20",
    status: "已结算 · 专票已开",
    statusEn: "Settled & Invoiced",
    doc: "增值税发票 (PDF)",
    docEn: "VAT Invoice (PDF)",
  },
  {
    cycle: "2026-01",
    cycleEn: "2026-01",
    id: "BILL-202601-620",
    mode: "按量后付费 (Postpaid)",
    gross: "$4,120.00",
    discount: "-$412.00",
    net: "$3,708.00",
    status: "已结算 · 专票已开",
    statusEn: "Settled & Invoiced",
    doc: "增值税发票 (PDF)",
    docEn: "VAT Invoice (PDF)",
  },
  {
    cycle: "2025-12",
    cycleEn: "2025-12",
    id: "BILL-202512-519",
    mode: "按量后付费 (Postpaid)",
    gross: "$2,950.00",
    discount: "-$295.00",
    net: "$2,655.00",
    status: "已结算 · 专票已开",
    statusEn: "Settled & Invoiced",
    doc: "增值税发票 (PDF)",
    docEn: "VAT Invoice (PDF)",
  },
];

const initialLedgerTransactions = [
  {
    time: "2026-03-01 10:30:18",
    txId: "TX_FIN_881920",
    type: "企业公对公电汇入账",
    typeEn: "Corporate Wire Deposit",
    isCredit: true,
    amount: "+$20,000.00",
    balance: "$24,850.00",
    channel: "DBS Bank 电汇 (Ref: DBS99182)",
    channelEn: "DBS Wire Transfer",
    status: "入账成功",
    statusEn: "Completed",
  },
  {
    time: "2026-03-01 02:00:00",
    txId: "TX_FIN_881402",
    type: "2026年2月月结扣款",
    typeEn: "Feb 2026 Monthly Settlement",
    isCredit: false,
    amount: "-$3,503.20",
    balance: "$4,850.00",
    channel: "系统自动划扣 (BILL-202602-841)",
    channelEn: "Auto Deduction",
    status: "划扣完成",
    statusEn: "Settled",
  },
  {
    time: "2026-02-15 14:22:00",
    txId: "TX_FIN_879011",
    type: "大客户专属续费返利",
    typeEn: "Annual Enterprise Rebate",
    isCredit: true,
    amount: "+$1,000.00",
    balance: "$8,353.20",
    channel: "商务特批赠券入账",
    channelEn: "Enterprise Incentive Credit",
    status: "已到账",
    statusEn: "Credited",
  },
  {
    time: "2026-02-01 02:00:00",
    txId: "TX_FIN_872190",
    type: "2026年1月月结扣款",
    typeEn: "Jan 2026 Monthly Settlement",
    isCredit: false,
    amount: "-$3,708.00",
    balance: "$7,353.20",
    channel: "系统自动划扣 (BILL-202601-620)",
    channelEn: "Auto Deduction",
    status: "划扣完成",
    statusEn: "Settled",
  },
  {
    time: "2026-01-10 16:45:10",
    txId: "TX_FIN_865412",
    type: "企业公对公电汇入账",
    typeEn: "Corporate Wire Deposit",
    isCredit: true,
    amount: "+$10,000.00",
    balance: "$11,061.20",
    channel: "DBS Bank 电汇 (Ref: DBS88471)",
    channelEn: "DBS Wire Transfer",
    status: "入账成功",
    statusEn: "Completed",
  },
];

export const CapabilityCloud = ({ onHome, onLogout }) => {
  // Language State: 'zh' by default, switchable to 'en'
  const [lang, setLang] = useState("zh");
  const t = i18n[lang];

  const [activeView, setActiveView] = useState("overview");
  const [activeCapability, setActiveCapability] = useState("text");
  const [environment, setEnvironment] = useState("Production");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [enterpriseBalance, setEnterpriseBalance] = useState(24850.0);
  const [ledgerList, setLedgerList] = useState(initialLedgerTransactions);
  const [topUpModalOpen, setTopUpModalOpen] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState(5000);
  const [topUpChannel, setTopUpChannel] = useState("wire");
  const [wireModalOpen, setWireModalOpen] = useState(false);
  const [ledgerFilter, setLedgerFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  
  // VOD Media Library States
  const [activeMedia, setActiveMedia] = useState(vodMediaLibrary[0]);
  const [vodCategory, setVodCategory] = useState("all");

  const capabilities = useMemo(() => getCapabilities(lang), [lang]);
  const navGroups = useMemo(() => getNavGroups(lang), [lang]);

  // Studio Playground states
  const [prompt, setPrompt] = useState(capabilities[0].samplePrompts[0].prompt);
  const [systemPrompt, setSystemPrompt] = useState(
    lang === "zh"
      ? "你是 GOLDLY AI，一个面向企业生产环境的高可用自主智能推理与音视频点播系统，提供低延迟与确定性交付。"
      : "You are GOLDLY AI, an enterprise-grade autonomous reasoning and VOD streaming platform designed for dependable delivery."
  );
  const [showSystemPrompt, setShowSystemPrompt] = useState(false);
  const [profile, setProfile] = useState("balanced"); // fast | balanced | quality
  const [temperature, setTemperature] = useState(0.4);
  const [maxTokens, setMaxTokens] = useState(2048);
  const [streaming, setStreaming] = useState(true);
  
  // Image-specific states
  const [aspectRatio, setAspectRatio] = useState("16:9");
  const [imageStyle, setImageStyle] = useState("photorealistic");
  
  // Video & VOD generation states
  const [videoDuration, setVideoDuration] = useState("10s");
  const [cameraMotion, setCameraMotion] = useState("pan_zoom");
  const [videoFps, setVideoFps] = useState("60");
  const [videoCodec, setVideoCodec] = useState("h265");
  const [includeAudio, setIncludeAudio] = useState(true);
  const [autoSubtitles, setAutoSubtitles] = useState(true);

  // Output states
  const [isRunning, setIsRunning] = useState(false);
  const [outputTab, setOutputTab] = useState("preview"); // preview | json | code
  const [codeLang, setCodeLang] = useState("curl"); // curl | python | node | go
  const [simulatedResult, setSimulatedResult] = useState(null);
  const [toastMessage, setToastMessage] = useState(null);

  const selectedCap = useMemo(
    () => capabilities.find((c) => c.id === activeCapability) || capabilities[0],
    [activeCapability, capabilities]
  );

  useEffect(() => {
    document.title = lang === "zh" ? "云控制台 | GOLDLY AI 点播与能力云" : "Console | GOLDLY AI VOD & Cloud";
  }, [lang]);

  const showToast = (msg) => {
    setToastMessage(msg);
    setTimeout(() => {
      setToastMessage(null);
    }, 3200);
  };

  const toggleLang = () => {
    setLang((prev) => (prev === "zh" ? "en" : "zh"));
    showToast(lang === "zh" ? "Switched to English interface" : "已切换为中文控制台");
  };

  const handleSelectCapability = (capId) => {
    setActiveCapability(capId);
    const targetCap = capabilities.find((c) => c.id === capId) || capabilities[0];
    setPrompt(targetCap.samplePrompts[0]?.prompt || "");
    setSimulatedResult(null);
  };

  // Switch to studio with selected VOD video parameters
  const handleForkToStudio = (mediaItem) => {
    setActiveCapability("video");
    setPrompt(mediaItem.prompt);
    setActiveView("studio");
    showToast(lang === "zh" ? `已将《${mediaItem.title}》导演参数导入 AI Studio！` : `Imported camera & prompt parameters to Studio!`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleRunTask = () => {
    setIsRunning(true);
    setSimulatedResult(null);

    const delay = activeCapability === "text" ? 1200 : activeCapability === "image" ? 2200 : 2800;

    setTimeout(() => {
      setIsRunning(false);
      const reqId = "req_" + Math.random().toString(36).substring(2, 10);
      
      if (activeCapability === "text") {
        setSimulatedResult({
          type: "text",
          content: lang === "zh"
            ? `### GOLDLY AI 深度推理与结构化分析结果\n\n针对输入需求，系统已通过新加坡亚太主节点完成端到端确定性分析：\n\n1. **宏观风险暴露评估**：供应链重叠度达 **34.2%**，主要集中在先进制程半导体与光刻耗材。\n2. **执行对冲方案**：建议建立双通道保税仓备件热备，降低单一关税区依赖。\n3. **SLA 与延迟保证**：已为您绑定边缘计算管道，P99 执行时延为 **280 ms**。`
            : `### GOLDLY AI Reasoning & Structured Synthesis\n\nExecution fulfilled via Singapore primary sovereign cluster with deterministic SLA:\n\n1. **Risk Vector Analysis**: Semiconductor overlap indexed at **34.2%** across advanced foundry consumables.\n2. **Hedging Recommendation**: Establish dual-channel bonded buffer stockpiles.\n3. **Latency SLA**: Singapore edge routing confirmed with **280 ms** P99 response.`,
          tokens: { prompt: 142, completion: 418, total: 560 },
          latency: "284 ms",
          requestId: reqId,
        });
      } else if (activeCapability === "image") {
        setSimulatedResult({
          type: "image",
          url: vodPosterTokyo,
          dimensions: "3840 x 2160 (4K UHD)",
          seed: "839410928",
          latency: "2.18 s",
          requestId: reqId,
          caption: prompt || (lang === "zh" ? "高保真写实渲染" : "High-fidelity photorealism"),
        });
      } else {
        // Video simulated output produces a full real playable VOD media item!
        const newVodItem = {
          id: "vod_" + reqId,
          title: prompt ? prompt.slice(0, 24) + "..." : "AI Generated Cinematic Sequence",
          category: "scifi",
          durationSec: videoDuration === "5s" ? 5 : 15,
          durationText: videoDuration === "5s" ? "00:05" : "00:15",
          resolution: "4K UHD (3840x2160)",
          fps: `${videoFps} fps`,
          codec: videoCodec === "h265" ? "H.265 / HEVC Main 10" : "AV1 Next-Gen",
          bitrate: "18.4 Mbps",
          audio: includeAudio ? "Dolby Atmos 5.1 / 320 kbps" : "Muted",
          videoUrl: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
          poster: vodPosterTokyo,
          views: "1 (Preview)",
          likes: "0",
          prompt: prompt,
          cameraMotion: cameraMotion,
          aspectRatio: aspectRatio,
          seed: "93841029",
          status: "Ready",
          subtitleZh: autoSubtitles ? "GOLDLY AI 时序视频渲染就绪，已生成自适应切片。" : "",
          subtitleEn: autoSubtitles ? "GOLDLY AI temporal render ready with adaptive HLS streams." : "",
        };
        setSimulatedResult({
          type: "video",
          media: newVodItem,
          latency: "16.8 s",
          requestId: reqId,
        });
      }
    }, delay);
  };

  const handleTopUpConfirm = () => {
    const amt = Number(topUpAmount) || 5000;
    const newBal = enterpriseBalance + amt;
    setEnterpriseBalance(newBal);
    const nowStr = new Date().toISOString().replace("T", " ").substring(0, 19);
    const txId = "TX_FIN_" + Math.floor(100000 + Math.random() * 900000);
    const channelName =
      topUpChannel === "wire"
        ? (lang === "zh" ? "DBS 企业电汇 (实时入账)" : "DBS Corporate Wire")
        : topUpChannel === "card"
        ? (lang === "zh" ? "VISA 商务信用卡 (•••• 8820)" : "VISA Corporate Card")
        : (lang === "zh" ? "企业快捷对公打款" : "Corporate Instant Pay");

    const newTx = {
      time: nowStr,
      txId: txId,
      type: lang === "zh" ? "企业在线充值入账" : "Online Balance Top-up",
      typeEn: "Online Balance Top-up",
      isCredit: true,
      amount: `+$${amt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      balance: `$${newBal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      channel: channelName,
      channelEn: channelName,
      status: lang === "zh" ? "入账成功" : "Completed",
      statusEn: "Completed",
    };
    setLedgerList([newTx, ...ledgerList]);
    setTopUpModalOpen(false);
    showToast(lang === "zh" ? `充值成功！已向企业资金账户充值 $${amt.toLocaleString()}，可用余额已更新为 $${newBal.toLocaleString()}` : `Top-up successful! Added $${amt.toLocaleString()}`);
  };

  const filteredLedger = useMemo(() => {
    if (ledgerFilter === "recharge") return ledgerList.filter((tx) => tx.isCredit);
    if (ledgerFilter === "deduct") return ledgerList.filter((tx) => !tx.isCredit);
    return ledgerList;
  }, [ledgerList, ledgerFilter]);

  const handleCopy = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      showToast(t.copied);
    }
  };

  // Filtered VOD media
  const filteredVodMedia = useMemo(() => {
    let list = vodMediaLibrary;
    if (vodCategory !== "all") {
      list = list.filter((m) => m.category === vodCategory);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      list = list.filter((m) => m.title.toLowerCase().includes(q) || m.prompt.toLowerCase().includes(q));
    }
    return list;
  }, [vodCategory, searchQuery]);

  return (
    <div className="gc-app-shell">
      {/* Toast Banner */}
      {toastMessage && (
        <div className="gc-toast-banner">
          <Icon name="check" size={14} />
          <span>{toastMessage}</span>
        </div>
      )}

      {/* Top Command Bar */}
      <header className="gc-topbar">
        <div className="gc-topbar-left">
          <button
            type="button"
            className="gc-mobile-menu-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle navigation menu"
          >
            <Icon name="overview" size={18} />
          </button>

          <div className="gc-brand" onClick={() => onHome?.("page-top")}>
            <span className="gc-brand-icon">
              <Icon name="sparkles" size={18} />
            </span>
            <div className="gc-brand-text">
              <span className="gc-brand-name">GOLDLY AI</span>
              <span className="gc-brand-tag">{t.brandConsole}</span>
            </div>
          </div>

          <div className="gc-topbar-divider"></div>

          {/* Environment Selector */}
          <div className="gc-env-selector">
            <span className="gc-status-dot"></span>
            <select
              value={environment}
              onChange={(e) => {
                setEnvironment(e.target.value);
                showToast(lang === "zh" ? `已切换至 ${e.target.value} 环境` : `Switched to ${e.target.value}`);
              }}
              className="gc-env-dropdown"
            >
              <option value="Production">{t.production}</option>
              <option value="Staging">{t.staging}</option>
              <option value="Development">{t.development}</option>
            </select>
          </div>
        </div>

        <div className="gc-topbar-center">
          <div className="gc-search-box">
            <Icon name="search" size={14} className="gc-search-icon" />
            <input
              type="text"
              placeholder={t.searchPlaceholder}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="gc-search-input"
            />
            <kbd className="gc-search-kbd">⌘K</kbd>
          </div>
        </div>

        <div className="gc-topbar-right">
          {/* Language Switcher */}
          <button
            type="button"
            className="gc-top-btn gc-lang-toggle"
            onClick={toggleLang}
            title={lang === "zh" ? "Switch to English" : "切换为中文"}
          >
            <Icon name="globe" size={14} />
            <span className="gc-lang-label">{lang === "zh" ? "EN / 英文" : "中 / 中文"}</span>
          </button>

          {/* Region Indicator */}
          <div className="gc-region-badge">
            <span className="gc-pulse-dot"></span>
            <span>{t.regionLabel}</span>
          </div>

          {/* Return Home Button */}
          <button
            type="button"
            className="gc-top-btn gc-back-home"
            onClick={() => onHome?.("page-top")}
          >
            <span>{t.corporateSite}</span>
            <Icon name="external" size={13} />
          </button>

          {/* Sign Out Button */}
          {onLogout && (
            <button
              type="button"
              className="gc-top-btn gc-back-home"
              onClick={() => onLogout()}
              title={lang === "zh" ? "退出控制台" : "Sign out"}
            >
              <span>{lang === "zh" ? "退出" : "Sign out"}</span>
            </button>
          )}
        </div>
      </header>

      {/* Main Workspace Body */}
      <div className="gc-body-layout">
        {/* Left Navigation Sidebar */}
        <aside className={`gc-sidebar ${sidebarOpen ? "open" : ""}`}>
          <div className="gc-sidebar-content">
            {navGroups.map((group, gIdx) => (
              <div key={gIdx} className="gc-nav-group">
                <div className="gc-nav-group-title">{group.label}</div>
                <div className="gc-nav-group-items">
                  {group.items.map((item) => {
                    const isActive = activeView === item.id;
                    return (
                      <button
                        type="button"
                        key={item.id}
                        className={`gc-nav-item ${isActive ? "active" : ""}`}
                        onClick={() => {
                          setActiveView(item.id);
                          setSidebarOpen(false);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        <span className="gc-nav-icon">
                          <Icon name={item.icon} size={15} />
                        </span>
                        <span className="gc-nav-label">{item.label}</span>
                        {item.badge && <span className="gc-nav-badge">{item.badge}</span>}
                        {item.badgeCount && <span className="gc-nav-counter">{item.badgeCount}</span>}
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          <div className="gc-sidebar-footer">
            <div className="gc-sla-badge">
              <span className="gc-sla-dot"></span>
              <div>
                <strong>{t.operational}</strong>
                <span>{t.operationalStatus}</span>
              </div>
            </div>
          </div>
        </aside>

        {/* Backdrop for mobile sidebar */}
        {sidebarOpen && <div className="gc-sidebar-backdrop" onClick={() => setSidebarOpen(false)}></div>}

        {/* Central Workspace Area */}
        <main className="gc-main-viewport">
          {/* ============================================================
              1. OVERVIEW VIEW
             ============================================================ */}
          {activeView === "overview" && (
            <div className="gc-view-container">
              {/* Workspace Header */}
              <div className="gc-hero-card">
                <div className="gc-hero-copy">
                  <h1 className="gc-hero-title">{t.heroTitle}</h1>
                  <p className="gc-hero-desc">{t.heroDesc}</p>
                  <div className="gc-hero-actions">
                    <button
                      type="button"
                      className="gc-btn gc-btn-primary"
                      onClick={() => setActiveView("vod")}
                    >
                      <Icon name="vod" size={14} />
                      {t.exploreVod}
                    </button>
                    <button
                      type="button"
                      className="gc-btn gc-btn-secondary"
                      onClick={() => setActiveView("studio")}
                    >
                      <Icon name="studio" size={14} />
                      {t.openStudio}
                    </button>
                    <button
                      type="button"
                      className="gc-btn gc-btn-secondary"
                      onClick={() => setActiveView("keys")}
                    >
                      <Icon name="keys" size={14} />
                      {t.manageKeys}
                    </button>
                  </div>
                </div>
              </div>

              {/* Operational KPI Strip */}
              <div className="gc-metric-grid">
                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.clusterSlaMetric}</span>
                    <Icon name="activity" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value highlight-green">{t.clusterSlaVal}</div>
                  <div className="gc-metric-footer">
                    <span>{t.clusterSlaSub}</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.totalInvocations}</span>
                    <Icon name="zap" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">4.82 M</div>
                  <div className="gc-metric-footer">
                    <span className="gc-trend-up">↑ 22.8%</span>
                    <span>API 推理与点播播放</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.vodAssetsMetric}</span>
                    <Icon name="film" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">{t.vodAssetsVal}</div>
                  <div className="gc-metric-footer">
                    <span>{t.vodAssetsSub}</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.vodBandwidthMetric}</span>
                    <Icon name="globe" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">1.82 TB</div>
                  <div className="gc-metric-footer">
                    <span>{t.vodBandwidthSub}</span>
                  </div>
                </div>
              </div>

              {/* VOD Featured Preview Spotlight */}
              <div className="gc-panel-card">
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">精选音视频点播与 AI 渲染实况</h3>
                    <p className="gc-panel-subtitle">点击即可在产品级点播播放器中直接试听、试看与切源</p>
                  </div>
                  <button
                    type="button"
                    className="gc-btn gc-btn-ghost-sm"
                    onClick={() => setActiveView("vod")}
                  >
                    <span>进入点播媒资库</span>
                    <Icon name="chevronRight" size={13} />
                  </button>
                </div>
                <div className="gc-panel-body no-pad">
                  <VodPlayer
                    media={activeMedia}
                    lang={lang}
                    onForkToStudio={handleForkToStudio}
                    onShowToast={showToast}
                  />
                </div>
              </div>

              {/* 14-Day Throughput Chart */}
              <div className="gc-panel-card">
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">{t.chartTitle}</h3>
                    <p className="gc-panel-subtitle">{t.chartSubtitle}</p>
                  </div>
                  <button
                    type="button"
                    className="gc-btn gc-btn-ghost-sm"
                    onClick={() => setActiveView("analytics")}
                  >
                    <span>{t.viewAnalytics}</span>
                    <Icon name="chevronRight" size={13} />
                  </button>
                </div>
                <div className="gc-panel-body">
                  <div className="gc-chart-container">
                    <div className="gc-chart-bars">
                      {usageTrendData.map((d, idx) => (
                        <div key={idx} className="gc-chart-bar-group">
                          <div className="gc-chart-bar-wrap">
                            <div
                              className="gc-chart-bar primary"
                              style={{ height: `${(d.requests / 3000) * 100}%` }}
                              title={`${d.day}: ${d.requests} 次点播与推理请求`}
                            ></div>
                            <div
                              className="gc-chart-bar secondary"
                              style={{ height: `${(d.bandwidth / 14) * 100}%` }}
                              title={`${d.day}: ${d.bandwidth} Gbps 峰值带宽`}
                            ></div>
                          </div>
                          <span className="gc-chart-label">{d.day}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Recent Jobs Table */}
              <div className="gc-panel-card">
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">{t.recentJobsTitle}</h3>
                    <p className="gc-panel-subtitle">{t.recentJobsSubtitle}</p>
                  </div>
                  <button
                    type="button"
                    className="gc-btn gc-btn-ghost-sm"
                    onClick={() => setActiveView("jobs")}
                  >
                    <span>{t.viewAllJobs}</span>
                    <Icon name="chevronRight" size={13} />
                  </button>
                </div>
                <div className="gc-table-responsive">
                  <table className="gc-table">
                    <thead>
                      <tr>
                        <th>{t.jobId}</th>
                        <th>{t.capability}</th>
                        <th>{t.operation}</th>
                        <th>{t.status}</th>
                        <th>{t.consumption}</th>
                        <th>{t.latency}</th>
                        <th>{t.dispatched}</th>
                        <th>{t.estimatedCost}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mockRecentJobs.map((job) => (
                        <tr key={job.id}>
                          <td><code>{job.id}</code></td>
                          <td><span className="gc-table-tag">{job.capability}</span></td>
                          <td>{job.action}</td>
                          <td>
                            <span className={`gc-status-pill ${job.status.toLowerCase()}`}>
                              {job.status === "Succeeded" ? <Icon name="check" size={11} /> : <span className="gc-spinner xs"></span>}
                              {job.status}
                            </span>
                          </td>
                          <td>{job.usage}</td>
                          <td>{job.duration}</td>
                          <td>{job.time}</td>
                          <td><code>{job.cost}</code></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              2. VOD MEDIA & STREAMING HUB (NEW DEDICATED VOD VIEW)
             ============================================================ */}
          {activeView === "vod" && (
            <div className="gc-view-container">
              {/* VOD Header */}
              <div className="gc-view-header">
                <div>
                  <div className="gc-view-eyebrow">
                    <span className="gc-badge-primary">VOD STREAMING CLOUD</span>
                    <span className="gc-hero-dot">•</span>
                    <span>HLS / DASH / 4K HEVC / AV1</span>
                  </div>
                  <h1 className="gc-view-title">{t.vodTitle}</h1>
                  <p className="gc-view-subtitle">{t.vodSubtitle}</p>
                </div>

                <div className="gc-view-actions">
                  <button
                    type="button"
                    className="gc-btn gc-btn-secondary"
                    onClick={() => {
                      setActiveCapability("video");
                      setActiveView("studio");
                    }}
                  >
                    <Icon name="studio" size={14} />
                    <span>{lang === "zh" ? "新建 AI 视频生成" : "New AI Video"}</span>
                  </button>
                  <button
                    type="button"
                    className="gc-btn gc-btn-primary"
                    onClick={() => {
                      showToast(lang === "zh" ? "正在启动自适应多码率转码流水线..." : "Triggering transcode workflow...");
                      setActiveView("jobs");
                    }}
                  >
                    <Icon name="refresh" size={14} />
                    <span>{lang === "zh" ? "批量转码工作流" : "Batch Transcode"}</span>
                  </button>
                </div>
              </div>

              {/* VOD Master Player Theater */}
              <div className="gc-vod-theater-panel">
                <div className="gc-vod-theater-header">
                  <div className="gc-vod-now-playing">
                    <span className="gc-pulse-dot"></span>
                    <strong>{lang === "zh" ? "当前点播播放源:" : "Now Streaming:"}</strong>
                    <span>{activeMedia.title}</span>
                  </div>
                  <div className="gc-vod-theater-meta">
                    <span>{t.viewsCount}: <strong>{activeMedia.views}</strong></span>
                    <span className="gc-sep">•</span>
                    <span>ID: <code>{activeMedia.id}</code></span>
                  </div>
                </div>

                <VodPlayer
                  media={activeMedia}
                  lang={lang}
                  onForkToStudio={handleForkToStudio}
                  onShowToast={showToast}
                />
              </div>

              {/* Media Library Filter Tabs */}
              <div className="gc-vod-filter-bar">
                <div className="gc-vod-category-tabs">
                  {[
                    { id: "all", label: t.filterAll },
                    { id: "cinematic", label: t.filterCinematic },
                    { id: "commercial", label: t.filterCommercial },
                    { id: "scifi", label: t.filterSciFi },
                    { id: "avatars", label: t.filterAvatars },
                    { id: "nature", label: t.filterNature },
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      type="button"
                      className={`gc-vod-filter-btn ${vodCategory === tab.id ? "active" : ""}`}
                      onClick={() => setVodCategory(tab.id)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                <div className="gc-vod-library-count">
                  <span>共 <strong>{filteredVodMedia.length}</strong> 部点播媒资已就绪</span>
                </div>
              </div>

              {/* Media Cards Gallery Grid (点播瀑布流网格) */}
              <div className="gc-vod-cards-grid">
                {filteredVodMedia.map((item) => {
                  const isCurrent = activeMedia.id === item.id;
                  return (
                    <div 
                      key={item.id} 
                      className={`gc-vod-card ${isCurrent ? "current-playing" : ""}`}
                      onClick={() => {
                        setActiveMedia(item);
                        showToast(lang === "zh" ? `已载入点播视频《${item.title}》` : `Loaded video: ${item.title}`);
                        window.scrollTo({ top: 180, behavior: "smooth" });
                      }}
                    >
                      <div className="gc-vod-card-thumb">
                        <img src={item.poster} alt={item.title} loading="lazy" />
                        <div className="gc-vod-thumb-overlay">
                          <div className="gc-vod-card-play-icon">
                            <Icon name="play" size={20} />
                          </div>
                        </div>
                        <div className="gc-vod-thumb-badges">
                          <span className="gc-thumb-pill">{item.durationText}</span>
                          <span className="gc-thumb-pill highlight">4K 60FPS</span>
                          <span className="gc-thumb-pill">{item.codec.split(" ")[0]}</span>
                        </div>
                        {isCurrent && <div className="gc-vod-playing-indicator">▶ 播放中</div>}
                      </div>

                      <div className="gc-vod-card-info">
                        <h4 className="gc-vod-card-title">{item.title}</h4>
                        <p className="gc-vod-card-prompt">{item.prompt}</p>
                        
                        <div className="gc-vod-card-bottom">
                          <div className="gc-vod-card-stats">
                            <span>{item.views} 次播放</span>
                            <span className="gc-sep">•</span>
                            <span className="gc-tag-green">转码就绪</span>
                          </div>
                          <div className="gc-vod-card-actions">
                            <button
                              type="button"
                              className="gc-btn-icon-link"
                              title={t.forkToStudio}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleForkToStudio(item);
                              }}
                            >
                              <Icon name="studio" size={14} />
                            </button>
                            <button
                              type="button"
                              className="gc-btn-icon-link"
                              title={t.copyStreamUrl}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigator.clipboard?.writeText(`https://vod.goldly.ai/v1/live/${item.id}.m3u8`);
                                showToast(t.streamCopied);
                              }}
                            >
                              <Icon name="copy" size={14} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* VOD Cloud Pipelines Section */}
              <div className="gc-panel-card">
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">{t.transcodingPipelines}</h3>
                    <p className="gc-panel-subtitle">支持自动化切片转码、自适应码率 (ABR)、AI 超分辨率增强与数字版权保护 (DRM)</p>
                  </div>
                  <span className="gc-badge-success">流水线正常</span>
                </div>
                <div className="gc-panel-body">
                  <div className="gc-pipeline-cards">
                    <div className="gc-pipe-card">
                      <div className="gc-pipe-header">
                        <Icon name="film" size={18} className="text-blue" />
                        <strong>VOD-UHD-4K-HEVC</strong>
                      </div>
                      <p>3840x2160 @ 60fps · 18 Mbps · H.265 Main 10 · 杜比全景声</p>
                      <div className="gc-pipe-meta">
                        <span className="gc-tag-blue">自适应切片</span>
                        <span className="gc-tag-green">就绪</span>
                      </div>
                    </div>

                    <div className="gc-pipe-card">
                      <div className="gc-pipe-header">
                        <Icon name="layers" size={18} className="text-violet" />
                        <strong>VOD-AI-SUPER-RES</strong>
                      </div>
                      <p>AI 智能画质超分重建 · 60FPS 运动补帧 · 弱光降噪</p>
                      <div className="gc-pipe-meta">
                        <span className="gc-tag-violet">AI增强</span>
                        <span className="gc-tag-green">就绪</span>
                      </div>
                    </div>

                    <div className="gc-pipe-card">
                      <div className="gc-pipe-header">
                        <Icon name="subtitles" size={18} className="text-amber" />
                        <strong>VOD-AI-SUBTITLES</strong>
                      </div>
                      <p>智能多语种语音转写 (ASR) · 毫秒级时间轴对齐 · 双语字幕流</p>
                      <div className="gc-pipe-meta">
                        <span className="gc-tag-amber">智能字幕</span>
                        <span className="gc-tag-green">就绪</span>
                      </div>
                    </div>

                    <div className="gc-pipe-card">
                      <div className="gc-pipe-header">
                        <Icon name="shield" size={18} className="text-emerald" />
                        <strong>VOD-DRM-AES128</strong>
                      </div>
                      <p>HLS 128-bit AES 动态密钥加密 · 鉴权防盗链 · 域名黑白名单</p>
                      <div className="gc-pipe-meta">
                        <span className="gc-tag-emerald">安全防护</span>
                        <span className="gc-tag-green">就绪</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              3. AI STUDIO VIEW (UPGRADED WITH VOD PLAYER CAPABILITY)
             ============================================================ */}
          {activeView === "studio" && (
            <div className="gc-view-container">
              {/* Breadcrumb */}
              <div className="gc-breadcrumb">
                <span>{t.studioTitle}</span>
                <Icon name="chevronRight" size={12} />
                <span className="gc-crumb-active">{selectedCap.name}</span>
              </div>

              {/* Capability Tabs */}
              <div className="gc-studio-tabs">
                {capabilities.map((cap) => (
                  <button
                    type="button"
                    key={cap.id}
                    className={`gc-studio-tab ${activeCapability === cap.id ? "active" : ""}`}
                    onClick={() => handleSelectCapability(cap.id)}
                  >
                    <span className={`gc-tab-dot ${cap.accent}`}></span>
                    <span className="gc-tab-name">{cap.name}</span>
                    <span className="gc-tab-latency">{cap.latency}</span>
                  </button>
                ))}
              </div>

              {/* Studio Workspace Layout */}
              <div className="gc-studio-grid">
                {/* Left Controls */}
                <div className="gc-controls-card">
                  {/* Presets Strip */}
                  <div className="gc-presets-row">
                    <span className="gc-presets-label">{t.tryPresets}</span>
                    <div className="gc-presets-chips">
                      {selectedCap.samplePrompts.map((preset, pIdx) => (
                        <button
                          type="button"
                          key={pIdx}
                          className="gc-preset-chip"
                          onClick={() => setPrompt(preset.prompt)}
                        >
                          {preset.title}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* System Prompt Toggle */}
                  <div className="gc-sysprompt-toggle-row">
                    <button
                      type="button"
                      className="gc-btn-text"
                      onClick={() => setShowSystemPrompt(!showSystemPrompt)}
                    >
                      <Icon name={showSystemPrompt ? "chevronDown" : "chevronRight"} size={13} />
                      <span>{t.systemPromptTitle}</span>
                    </button>
                  </div>

                  {showSystemPrompt && (
                    <div className="gc-sysprompt-box">
                      <textarea
                        rows={2}
                        value={systemPrompt}
                        onChange={(e) => setSystemPrompt(e.target.value)}
                        placeholder={t.systemPromptPlaceholder}
                        className="gc-textarea"
                      />
                    </div>
                  )}

                  {/* Main User Prompt */}
                  <div className="gc-prompt-box">
                    <div className="gc-prompt-header">
                      <label className="gc-label">{t.userPromptLabel}</label>
                      <span className="gc-char-counter">{prompt.length} / 4,000 {t.charLimit}</span>
                    </div>
                    <textarea
                      rows={5}
                      value={prompt}
                      onChange={(e) => setPrompt(e.target.value)}
                      placeholder={
                        activeCapability === "text"
                          ? (lang === "zh" ? "键入您的生产级推理指令、上下文或提取规则..." : "Type instructions or reasoning tasks...")
                          : activeCapability === "image"
                          ? (lang === "zh" ? "描述商业视觉资产场景、光影、构图与负向约束..." : "Describe visual subject, studio lighting, materials...")
                          : (lang === "zh" ? "描述电影级镜头运镜、主体动作、时序节奏与环境声效..." : "Describe cinematic movement, camera dynamics, temporal sequence...")
                      }
                      className="gc-textarea gc-textarea-lg"
                    />
                  </div>

                  {/* Modality Specific Controls */}
                  {activeCapability === "image" && (
                    <div className="gc-subcontrol-row">
                      <div className="gc-subcontrol-item">
                        <label>{t.aspectRatio}</label>
                        <div className="gc-ratio-selector">
                          {["1:1", "16:9", "9:16", "4:3"].map((r) => (
                            <button
                              type="button"
                              key={r}
                              className={`gc-ratio-btn ${aspectRatio === r ? "active" : ""}`}
                              onClick={() => setAspectRatio(r)}
                            >
                              {r}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="gc-subcontrol-item">
                        <label>{t.styleAesthetic}</label>
                        <select value={imageStyle} onChange={(e) => setImageStyle(e.target.value)} className="gc-select">
                          <option value="photorealistic">{lang === "zh" ? "写实商业摄影" : "Photorealistic Commercial"}</option>
                          <option value="cinematic">{lang === "zh" ? "35毫米电影胶片" : "Cinematic 35mm Film"}</option>
                          <option value="minimalist">{lang === "zh" ? "极简 3D 静物" : "Minimalist 3D Studio"}</option>
                          <option value="architectural">{lang === "zh" ? "现代建筑透视渲染" : "Architectural Rendering"}</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {activeCapability === "video" && (
                    <div className="gc-video-controls-block">
                      <div className="gc-subcontrol-row">
                        <div className="gc-subcontrol-item">
                          <label>{t.sequenceDuration}</label>
                          <div className="gc-ratio-selector">
                            {["5s", "10s", "15s"].map((d) => (
                              <button
                                type="button"
                                key={d}
                                className={`gc-ratio-btn ${videoDuration === d ? "active" : ""}`}
                                onClick={() => setVideoDuration(d)}
                              >
                                {d}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="gc-subcontrol-item">
                          <label>{t.cameraDynamic}</label>
                          <select value={cameraMotion} onChange={(e) => setCameraMotion(e.target.value)} className="gc-select">
                            <option value="pan_zoom">{lang === "zh" ? "平滑推近 (Pan & Zoom)" : "Slow Pan & Zoom In"}</option>
                            <option value="orbit">{lang === "zh" ? "环绕运镜 (Orbit)" : "Circular Orbit"}</option>
                            <option value="fpv">{lang === "zh" ? "高速穿梭机 (FPV Drone)" : "High-Speed FPV Drone"}</option>
                            <option value="static">{lang === "zh" ? "固定机位 (Static)" : "Static Tripod"}</option>
                          </select>
                        </div>
                      </div>

                      {/* VOD High-End Streaming Controls */}
                      <div className="gc-subcontrol-row">
                        <div className="gc-subcontrol-item">
                          <label>{t.fpsLabel}</label>
                          <div className="gc-ratio-selector">
                            {["24", "30", "60"].map((f) => (
                              <button
                                type="button"
                                key={f}
                                className={`gc-ratio-btn ${videoFps === f ? "active" : ""}`}
                                onClick={() => setVideoFps(f)}
                              >
                                {f} FPS
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="gc-subcontrol-item">
                          <label>{t.codecLabel}</label>
                          <select value={videoCodec} onChange={(e) => setVideoCodec(e.target.value)} className="gc-select">
                            <option value="h265">H.265 / HEVC Main 10 (4K推荐)</option>
                            <option value="h264">H.264 High Profile (通用兼容)</option>
                            <option value="av1">AV1 Next-Gen (极高压缩比)</option>
                            <option value="prores">Apple ProRes 422 (影视母带)</option>
                          </select>
                        </div>
                      </div>

                      <div className="gc-toggles-row">
                        <label className="gc-toggle-label">
                          <input
                            type="checkbox"
                            checked={includeAudio}
                            onChange={(e) => setIncludeAudio(e.target.checked)}
                          />
                          <span>{t.soundtrackLabel}</span>
                        </label>
                        <label className="gc-toggle-label">
                          <input
                            type="checkbox"
                            checked={autoSubtitles}
                            onChange={(e) => setAutoSubtitles(e.target.checked)}
                          />
                          <span>{t.autoSubtitlesLabel}</span>
                        </label>
                      </div>
                    </div>
                  )}

                  {/* Tier Selector */}
                  <div className="gc-tier-selector-block">
                    <label className="gc-label">{t.profileTier}</label>
                    <div className="gc-tier-options">
                      {[
                        { id: "fast", title: t.tierFast, desc: t.tierFastDesc },
                        { id: "balanced", title: t.tierBalanced, desc: t.tierBalancedDesc },
                        { id: "quality", title: t.tierQuality, desc: t.tierQualityDesc },
                      ].map((ti) => (
                        <div
                          key={ti.id}
                          className={`gc-tier-card ${profile === ti.id ? "active" : ""}`}
                          onClick={() => setProfile(ti.id)}
                        >
                          <strong>{ti.title}</strong>
                          <p>{ti.desc}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Action Trigger Bar */}
                  <div className="gc-trigger-bar">
                    <div className="gc-trigger-meta">
                      <span>{t.endpointLabel}: <code>{selectedCap.endpoint}</code></span>
                      <span className="gc-sep">•</span>
                      <span>{t.estSLA}: ~{selectedCap.latency}</span>
                    </div>
                    <div className="gc-trigger-buttons">
                      <button
                        type="button"
                        className="gc-btn gc-btn-ghost-sm"
                        onClick={() => {
                          setPrompt("");
                          setSimulatedResult(null);
                        }}
                      >
                        {t.clear}
                      </button>
                      <button
                        type="button"
                        className="gc-btn gc-btn-primary"
                        disabled={isRunning}
                        onClick={handleRunTask}
                      >
                        {isRunning ? (
                          <>
                            <span className="gc-spinner"></span>
                            {t.processing}
                          </>
                        ) : (
                          <>
                            <Icon name="play" size={13} />
                            {t.runTask}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Right Results Screen */}
                <div className="gc-output-card">
                  <div className="gc-output-header">
                    <div className="gc-output-tabs">
                      <button
                        type="button"
                        className={`gc-output-tab ${outputTab === "preview" ? "active" : ""}`}
                        onClick={() => setOutputTab("preview")}
                      >
                        <Icon name="sparkles" size={14} />
                        {t.liveResult}
                      </button>
                      <button
                        type="button"
                        className={`gc-output-tab ${outputTab === "json" ? "active" : ""}`}
                        onClick={() => setOutputTab("json")}
                      >
                        <Icon name="terminal" size={14} />
                        {t.rawJson}
                      </button>
                      <button
                        type="button"
                        className={`gc-output-tab ${outputTab === "code" ? "active" : ""}`}
                        onClick={() => setOutputTab("code")}
                      >
                        <Icon name="copy" size={14} />
                        {t.integrationCode}
                      </button>
                    </div>

                    {simulatedResult && (
                      <div className="gc-output-telemetry">
                        <span className="gc-tag-green">200 OK</span>
                        <span>{t.latency}: <strong>{simulatedResult.latency}</strong></span>
                        <span className="gc-sep">•</span>
                        <span>ID: <code>{simulatedResult.requestId}</code></span>
                      </div>
                    )}
                  </div>

                  <div className="gc-output-body">
                    {isRunning ? (
                      <div className="gc-output-loading-state">
                        <div className="gc-pulse-ring"></div>
                        <strong>{lang === "zh" ? "正在执行边缘时序渲染与切片流水线..." : "Executing Temporal Inference & Slicing..."}</strong>
                        <p>{lang === "zh" ? "通过新加坡主权高可用节点进行时序计算与自适应转码。" : "Synthesizing through sovereign edge routing with ABR packaging."}</p>
                      </div>
                    ) : outputTab === "preview" ? (
                      simulatedResult ? (
                        <div className="gc-rendered-result">
                          {/* Text Output */}
                          {simulatedResult.type === "text" && (
                            <div className="gc-markdown-output">
                              <div className="gc-rendered-markdown" dangerouslySetInnerHTML={{ __html: simulatedResult.content.replace(/\n\n/g, "<br/><br/>").replace(/### (.*)/g, "<h4>$1</h4>").replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />
                              <div className="gc-token-footer">
                                <span>Prompt: {simulatedResult.tokens.prompt}</span>
                                <span>Completion: {simulatedResult.tokens.completion}</span>
                                <span>Total: {simulatedResult.tokens.total} tokens</span>
                                <button type="button" className="gc-btn-text" onClick={() => handleCopy(simulatedResult.content)}>
                                  <Icon name="copy" size={12} /> {t.copyOutput}
                                </button>
                              </div>
                            </div>
                          )}

                          {/* Image Output */}
                          {simulatedResult.type === "image" && (
                            <div className="gc-visual-output">
                              <div className="gc-image-card">
                                <img src={simulatedResult.url} alt="Generated result" />
                                <div className="gc-image-overlay">
                                  <span className="gc-img-badge">{simulatedResult.dimensions}</span>
                                  <span className="gc-img-badge">Seed: {simulatedResult.seed}</span>
                                  <button type="button" className="gc-btn gc-btn-secondary gc-btn-xs" onClick={() => showToast(lang === "zh" ? "正在下载 4K 高清资产..." : "Downloading 4K asset...")}>
                                    {lang === "zh" ? "下载高清原图" : "Download Asset"}
                                  </button>
                                </div>
                              </div>
                              <p className="gc-img-caption">{simulatedResult.caption}</p>
                            </div>
                          )}

                          {/* Video Output: PRODUCT-GRADE VOD PLAYER */}
                          {simulatedResult.type === "video" && (
                            <div className="gc-video-player-output">
                              <VodPlayer
                                media={simulatedResult.media}
                                lang={lang}
                                onForkToStudio={handleForkToStudio}
                                onShowToast={showToast}
                              />
                              <div className="gc-video-publish-banner">
                                <button
                                  type="button"
                                  className="gc-btn gc-btn-primary"
                                  onClick={() => {
                                    showToast(t.publishedSuccess);
                                    setActiveMedia(simulatedResult.media);
                                    setActiveView("vod");
                                  }}
                                >
                                  <Icon name="vod" size={14} />
                                  <span>{t.publishToVod}</span>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="gc-output-empty-state">
                          <div className="gc-empty-icon"><Icon name="studio" size={32} /></div>
                          <h3>{lang === "zh" ? "工作台就绪，等待派发" : "Ready for Execution"}</h3>
                          <p>{lang === "zh" ? "选择上方的场景预设或键入提示词，点击右下角【执行生成任务】即可体验。" : "Select a preset or customize prompt above, then click Run Generation Task to trigger engine."}</p>
                        </div>
                      )
                    ) : outputTab === "json" ? (
                      <div className="gc-code-screen">
                        <pre>
                          {JSON.stringify(
                            simulatedResult
                              ? simulatedResult
                              : {
                                  status: "ready",
                                  engine: "goldly-production-v2",
                                  region: "ap-southeast-1",
                                  timestamp: new Date().toISOString(),
                                  selectedCapability: activeCapability,
                                },
                            null,
                            2
                          )}
                        </pre>
                      </div>
                    ) : (
                      <div className="gc-code-screen">
                        <div className="gc-code-lang-selector">
                          {["curl", "python", "node", "go"].map((l) => (
                            <button
                              key={l}
                              type="button"
                              className={`gc-lang-chip ${codeLang === l ? "active" : ""}`}
                              onClick={() => setCodeLang(l)}
                            >
                              {l.toUpperCase()}
                            </button>
                          ))}
                        </div>
                        <pre>
                          {codeLang === "curl" &&
                            `curl -X POST "https://api.goldly.ai${selectedCap.endpoint}" \\\n  -H "Authorization: Bearer gl_live_9a4f210..." \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "prompt": "${prompt.replace(/"/g, '\\"')}",\n    "tier": "${profile}"\n  }'`}
                          {codeLang === "python" &&
                            `import requests\n\nresp = requests.post(\n    "https://api.goldly.ai${selectedCap.endpoint}",\n    headers={"Authorization": "Bearer gl_live_9a4f210..."},\n    json={\n        "prompt": "${prompt.replace(/"/g, '\\"')}",\n        "tier": "${profile}"\n    }\n)\nprint(resp.json())`}
                          {codeLang === "node" &&
                            `import { GoldlyAI } from '@goldly/ai-sdk';\n\nconst client = new GoldlyAI({ apiKey: process.env.GOLDLY_API_KEY });\n\nconst result = await client.${activeCapability}.generate({\n  prompt: "${prompt.replace(/"/g, '\\"')}",\n  tier: "${profile}"\n});\nconsole.log(result);`}
                          {codeLang === "go" &&
                            `package main\n\nimport (\n  "context"\n  "fmt"\n  "github.com/goldly-ai/sdk-go"\n)\n\nfunc main() {\n  client := goldly.NewClient("gl_live_9a4f210...")\n  resp, err := client.Generate(context.Background(), &goldly.Req{\n    Prompt: "${prompt.replace(/"/g, '\\"')}",\n  })\n  fmt.Println(resp)\n}`}
                        </pre>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              4. CAPABILITIES CATALOG VIEW
             ============================================================ */}
          {activeView === "capabilities" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{t.catalogTitle}</h1>
                  <p className="gc-view-subtitle">{t.catalogDesc}</p>
                </div>
              </div>

              <div className="gc-catalog-grid">
                {capabilities.map((cap) => (
                  <div key={cap.id} className="gc-cap-card large">
                    <div className="gc-cap-card-header">
                      <span className={`gc-cap-badge ${cap.accent}`}>{cap.badge}</span>
                      <span className="gc-cap-status">
                        <span className="gc-status-dot"></span>
                        {cap.status}
                      </span>
                    </div>
                    <h3 className="gc-cap-name">{cap.name}</h3>
                    <p className="gc-cap-headline">{cap.headline}</p>
                    <p className="gc-cap-desc">{cap.description}</p>
                    
                    <div className="gc-cap-features-block">
                      <h4>核心架构特性:</h4>
                      <div className="gc-cap-features">
                        {cap.features.map((f, i) => (
                          <span key={i} className="gc-feature-tag">
                            <Icon name="check" size={11} /> {f}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="gc-cap-footer">
                      <div className="gc-cap-meta">
                        <span>{t.endpointLabel}: <code>{cap.endpoint}</code></span>
                        <span className="gc-sep">•</span>
                        <span>{t.estSLA}: ~{cap.latency}</span>
                      </div>
                      <button
                        type="button"
                        className="gc-btn gc-btn-primary gc-btn-sm"
                        onClick={() => {
                          handleSelectCapability(cap.id);
                          setActiveView("studio");
                        }}
                      >
                        <span>{lang === "zh" ? "进入工坊调试" : "Launch Studio"}</span>
                        <Icon name="chevronRight" size={13} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ============================================================
              5. JOBS & TRANSCODING PIPELINES VIEW
             ============================================================ */}
          {activeView === "jobs" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{t.recentJobsTitle}</h1>
                  <p className="gc-view-subtitle">{t.recentJobsSubtitle}</p>
                </div>
                <button
                  type="button"
                  className="gc-btn gc-btn-secondary"
                  onClick={() => showToast(lang === "zh" ? "已导出近期流水线 CSV 报告" : "Exported CSV report")}
                >
                  <Icon name="download" size={14} />
                  <span>{t.exportCsv}</span>
                </button>
              </div>

              <div className="gc-panel-card">
                <div className="gc-table-responsive">
                  <table className="gc-table">
                    <thead>
                      <tr>
                        <th>{t.jobId}</th>
                        <th>{t.capability}</th>
                        <th>{t.operation}</th>
                        <th>{t.status}</th>
                        <th>{t.consumption}</th>
                        <th>{t.latency}</th>
                        <th>{t.dispatched}</th>
                        <th>{t.estimatedCost}</th>
                        <th>{t.actions}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mockRecentJobs.map((job) => (
                        <tr key={job.id}>
                          <td><code>{job.id}</code></td>
                          <td><span className="gc-table-tag">{job.capability}</span></td>
                          <td><strong>{job.action}</strong></td>
                          <td>
                            <span className={`gc-status-pill ${job.status.toLowerCase()}`}>
                              {job.status === "Succeeded" ? <Icon name="check" size={11} /> : <span className="gc-spinner xs"></span>}
                              {job.status}
                            </span>
                          </td>
                          <td>{job.usage}</td>
                          <td>{job.duration}</td>
                          <td>{job.time}</td>
                          <td><code>{job.cost}</code></td>
                          <td>
                            <button
                              type="button"
                              className="gc-btn-text"
                              onClick={() => showToast(`查看流水线 ${job.id} 执行日志与链路元数据`)}
                            >
                              {t.details}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              6. VOD TELEMETRY & ANALYTICS VIEW
             ============================================================ */}
          {activeView === "analytics" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{t.analyticsTitle}</h1>
                  <p className="gc-view-subtitle">{t.analyticsSubtitle}</p>
                </div>
                <div className="gc-view-actions">
                  <span className="gc-badge-success">实时遥测流在线</span>
                </div>
              </div>

              {/* VOD Analytics KPI Cards */}
              <div className="gc-metric-grid">
                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.ttfbMetric}</span>
                    <Icon name="clock" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value highlight-blue">142 ms</div>
                  <div className="gc-metric-footer">
                    <span>亚太及欧美 14 个边缘节点聚合</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.rebufferingMetric}</span>
                    <Icon name="zap" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value highlight-green">0.07%</div>
                  <div className="gc-metric-footer">
                    <span>99.93% 播放平滑无卡顿</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.peakBandwidthMetric}</span>
                    <Icon name="globe" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">18.4 Gbps</div>
                  <div className="gc-metric-footer">
                    <span>今日晚间峰值吞吐</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{t.avgCompletionMetric}</span>
                    <Icon name="film" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">84.2%</div>
                  <div className="gc-metric-footer">
                    <span>高保真短剧与广告完播表现</span>
                  </div>
                </div>
              </div>

              {/* Resolution and Codec Distribution */}
              <div className="gc-panel-card">
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">流媒体码率与编码格式分布</h3>
                    <p className="gc-panel-subtitle">按实际客户端下发流量与自适应切片统计</p>
                  </div>
                </div>
                <div className="gc-panel-body">
                  <div className="gc-dist-bars">
                    <div className="gc-dist-item">
                      <div className="gc-dist-labels">
                        <span>4K 60FPS (H.265 / HEVC 10-bit)</span>
                        <strong>48.6% (8.9 Gbps)</strong>
                      </div>
                      <div className="gc-dist-bar-track">
                        <div className="gc-dist-bar-fill primary" style={{ width: "48.6%" }}></div>
                      </div>
                    </div>

                    <div className="gc-dist-item">
                      <div className="gc-dist-labels">
                        <span>1080P FHD (AV1 / H.264 High)</span>
                        <strong>38.2% (7.0 Gbps)</strong>
                      </div>
                      <div className="gc-dist-bar-track">
                        <div className="gc-dist-bar-fill secondary" style={{ width: "38.2%" }}></div>
                      </div>
                    </div>

                    <div className="gc-dist-item">
                      <div className="gc-dist-labels">
                        <span>720P HD (移动端弱网备选)</span>
                        <strong>13.2% (2.5 Gbps)</strong>
                      </div>
                      <div className="gc-dist-bar-track">
                        <div className="gc-dist-bar-fill tertiary" style={{ width: "13.2%" }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              7. API KEYS VIEW
             ============================================================ */}
          {activeView === "keys" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{t.apiKeysTitle}</h1>
                  <p className="gc-view-subtitle">{t.apiKeysDesc}</p>
                </div>
                <button
                  type="button"
                  className="gc-btn gc-btn-primary"
                  onClick={() => showToast(lang === "zh" ? "已创建新生产凭证: gl_live_..." : "Created new key: gl_live_...")}
                >
                  <Icon name="keys" size={14} />
                  <span>{t.createKey}</span>
                </button>
              </div>

              <div className="gc-security-tip-card">
                <Icon name="shield" size={20} className="gc-tip-icon" />
                <div>
                  <strong>{t.keySecurityTip}</strong>
                  <p>{t.keySecurityDesc}</p>
                </div>
              </div>

              <div className="gc-panel-card">
                <div className="gc-table-responsive">
                  <table className="gc-table">
                    <thead>
                      <tr>
                        <th>密钥名称</th>
                        <th>令牌前缀</th>
                        <th>创建环境</th>
                        <th>权限范围</th>
                        <th>创建时间</th>
                        <th>最后活跃</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>Production VOD Ingest & Stream</strong></td>
                        <td><code>gl_live_9a4f210•••••••</code></td>
                        <td><span className="gc-table-tag">Production</span></td>
                        <td>全模态推理 + VOD 切片推流</td>
                        <td>2026-08-12</td>
                        <td>刚刚 (04:12 UTC)</td>
                        <td>
                          <button type="button" className="gc-btn-text" onClick={() => handleCopy("gl_live_9a4f21087e6a18d9b")}>
                            {t.copyCode}
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Staging Sandbox Token</strong></td>
                        <td><code>gl_test_3b8k991•••••••</code></td>
                        <td><span className="gc-table-tag">Staging</span></td>
                        <td>只读点播播放 + 沙箱推理</td>
                        <td>2026-08-20</td>
                        <td>3 小时前</td>
                        <td>
                          <button type="button" className="gc-btn-text" onClick={() => handleCopy("gl_test_3b8k9914710a")}>
                            {t.copyCode}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              8. RESOURCE USAGE & QUOTAS VIEW
             ============================================================ */}
          {activeView === "usage" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{t.usageTitle}</h1>
                  <p className="gc-view-subtitle">{t.usageDesc}</p>
                </div>
                <div className="gc-view-actions">
                  <button
                    type="button"
                    className="gc-btn gc-btn-secondary"
                    onClick={() => showToast(lang === "zh" ? "正在导出资源用量时序明细 (CSV)..." : "Exporting usage telemetry...")}
                  >
                    <Icon name="download" size={14} />
                    <span>{t.exportUsage || (lang === "zh" ? "导出用量明细" : "Export Telemetry")}</span>
                  </button>
                  <button
                    type="button"
                    className="gc-btn gc-btn-primary"
                    onClick={() => showToast(lang === "zh" ? "配额提升申请已提交，专属架构师将在 2 小时内审批" : "Quota increase request submitted")}
                  >
                    <Icon name="sliders" size={14} />
                    <span>{t.requestQuota || (lang === "zh" ? "申请扩容配额" : "Request Quota")}</span>
                  </button>
                </div>
              </div>

              <div className="gc-metric-grid">
                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "AI 视频与 4K 超分核时" : "GPU Render Seconds"}</span>
                    <Icon name="activity" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">1,420 秒</div>
                  <div className="gc-metric-footer">
                    <span>月度软配额 10,000 秒 (已用 14.2%)</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "VOD 点播流媒体出网流量" : "VOD Egress Bandwidth"}</span>
                    <Icon name="globe" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">24.8 TB</div>
                  <div className="gc-metric-footer">
                    <span>月度分配配额 100 TB (已用 24.8%)</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "冷热分层对象媒资存储" : "VOD Object Storage"}</span>
                    <Icon name="layers" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">1.82 TB</div>
                  <div className="gc-metric-footer">
                    <span>存储空间上限 10 TB (健康率 100%)</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "API 智能网关瞬时并发" : "Gateway Peak QPS"}</span>
                    <Icon name="zap" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value highlight-green">420 QPS</div>
                  <div className="gc-metric-footer">
                    <span>并发硬限制 2,000 QPS (无流控告警)</span>
                  </div>
                </div>
              </div>

              {/* Resource Quota Allocation Table */}
              <div className="gc-panel-card" style={{ marginTop: "20px" }}>
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">{lang === "zh" ? "生产资源配额分配与使用率" : "Production Quotas Allocation"}</h3>
                    <p className="gc-panel-subtitle">{lang === "zh" ? "当前工作空间在新加坡主集群及全球边缘节点的资源配额" : "Allocated capacity and quotas across Singapore and edge nodes"}</p>
                  </div>
                </div>
                <div className="gc-table-responsive">
                  <table className="gc-table">
                    <thead>
                      <tr>
                        <th>{lang === "zh" ? "资源配额项目" : "Quota Dimension"}</th>
                        <th>{lang === "zh" ? "已用量" : "Used"}</th>
                        <th>{lang === "zh" ? "配额上限" : "Total Limit"}</th>
                        <th>{lang === "zh" ? "使用率" : "Utilization"}</th>
                        <th>{lang === "zh" ? "健康状态" : "Status"}</th>
                        <th>{lang === "zh" ? "操作" : "Action"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>{lang === "zh" ? "AI 视频时序渲染时长 (4K 60FPS)" : "AI Temporal Render (4K 60FPS)"}</strong></td>
                        <td>1,420 秒</td>
                        <td>10,000 秒 / 月</td>
                        <td>
                          <div className="gc-billing-pacing-bar">
                            <div className="gc-billing-pacing-fill" style={{ width: "14.2%" }}></div>
                          </div>
                        </td>
                        <td><span className="gc-tag-green">{lang === "zh" ? "充足 (Normal)" : "Normal"}</span></td>
                        <td>
                          <button type="button" className="gc-btn gc-btn-ghost-sm" onClick={() => showToast(lang === "zh" ? "已发起 GPU 渲染核时扩容申请" : "Quota requested")}>
                            {lang === "zh" ? "申请扩容" : "Increase"}
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>{lang === "zh" ? "全球 CDN 点播出网流量" : "Global CDN VOD Egress"}</strong></td>
                        <td>24.8 TB</td>
                        <td>100.0 TB / 月</td>
                        <td>
                          <div className="gc-billing-pacing-bar">
                            <div className="gc-billing-pacing-fill" style={{ width: "24.8%" }}></div>
                          </div>
                        </td>
                        <td><span className="gc-tag-green">{lang === "zh" ? "充足 (Normal)" : "Normal"}</span></td>
                        <td>
                          <button type="button" className="gc-btn gc-btn-ghost-sm" onClick={() => showToast(lang === "zh" ? "已发起 CDN 流量池扩容申请" : "Quota requested")}>
                            {lang === "zh" ? "申请扩容" : "Increase"}
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>{lang === "zh" ? "持久化 4K 媒资与切片存储" : "VOD Storage & Slices"}</strong></td>
                        <td>1.82 TB</td>
                        <td>10.0 TB</td>
                        <td>
                          <div className="gc-billing-pacing-bar">
                            <div className="gc-billing-pacing-fill" style={{ width: "18.2%" }}></div>
                          </div>
                        </td>
                        <td><span className="gc-tag-green">{lang === "zh" ? "充足 (Normal)" : "Normal"}</span></td>
                        <td>
                          <button type="button" className="gc-btn gc-btn-ghost-sm" onClick={() => showToast(lang === "zh" ? "已发起存储空间扩容申请" : "Quota requested")}>
                            {lang === "zh" ? "申请扩容" : "Increase"}
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>{lang === "zh" ? "API 智能网关瞬时并发 (QPS)" : "Gateway Peak QPS"}</strong></td>
                        <td>420 QPS</td>
                        <td>2,000 QPS</td>
                        <td>
                          <div className="gc-billing-pacing-bar">
                            <div className="gc-billing-pacing-fill" style={{ width: "21.0%" }}></div>
                          </div>
                        </td>
                        <td><span className="gc-tag-green">{lang === "zh" ? "充足 (Normal)" : "Normal"}</span></td>
                        <td>
                          <button type="button" className="gc-btn gc-btn-ghost-sm" onClick={() => showToast(lang === "zh" ? "已发起 QPS 提额申请" : "Quota requested")}>
                            {lang === "zh" ? "申请扩容" : "Increase"}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              9. LOGS & AUDIT VIEW
             ============================================================ */}
          {activeView === "logs" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{t.logsTitle}</h1>
                  <p className="gc-view-subtitle">{t.logsDesc}</p>
                </div>
                <button type="button" className="gc-btn gc-btn-secondary">
                  <span className="gc-pulse-dot"></span>
                  <span>{t.liveTail}</span>
                </button>
              </div>

              <div className="gc-panel-card">
                <div className="gc-table-responsive">
                  <table className="gc-table">
                    <thead>
                      <tr>
                        <th>时间戳 (UTC)</th>
                        <th>方法</th>
                        <th>请求端点</th>
                        <th>状态码</th>
                        <th>边缘耗时</th>
                        <th>请求追踪 ID</th>
                        <th>客户端 IP</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mockLogs.map((l, i) => (
                        <tr key={i}>
                          <td><code>{l.time}</code></td>
                          <td><span className="gc-table-tag">{l.method}</span></td>
                          <td><code>{l.endpoint}</code></td>
                          <td><span className="gc-tag-green">{l.status}</span></td>
                          <td>{l.latency}</td>
                          <td><code>{l.id}</code></td>
                          <td>{l.ip}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              10. SECURITY & DRM VIEW
             ============================================================ */}
          {activeView === "security" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{t.securityTitle}</h1>
                  <p className="gc-view-subtitle">{t.securityDesc}</p>
                </div>
                <button type="button" className="gc-btn gc-btn-primary" onClick={() => showToast(lang === "zh" ? "已邀请新协作者" : "Invited member")}>
                  <Icon name="shield" size={14} />
                  <span>{t.inviteMember}</span>
                </button>
              </div>

              <div className="gc-capabilities-grid">
                <div className="gc-cap-card">
                  <h4 className="gc-cap-name">HLS 128-bit AES 动态加密</h4>
                  <p className="gc-cap-desc">在视频切片上传及边缘分发时，对每一个 ts 分片进行动态 AES 128-bit 加密，防止离线录屏与原始文件抓取。</p>
                  <div className="gc-cap-footer">
                    <span className="gc-tag-green">策略生效中</span>
                  </div>
                </div>

                <div className="gc-cap-card">
                  <h4 className="gc-cap-name">时间戳 Token 防盗链</h4>
                  <p className="gc-cap-desc">每个点播播放链接均携带服务端签名校验串 (auth_key) 与毫秒级过期时效，有效杜绝第三方未授权盗播。</p>
                  <div className="gc-cap-footer">
                    <span className="gc-tag-green">策略生效中</span>
                  </div>
                </div>

                <div className="gc-cap-card">
                  <h4 className="gc-cap-name">主权数据零留存 (Zero Retention)</h4>
                  <p className="gc-cap-desc">企业级数据边界隔离，所有输入提示词、业务日志与音视频原片绝不被纳入任何公开模型再训练。</p>
                  <div className="gc-cap-footer">
                    <span className="gc-tag-green">已签署企业 SLA</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              11. BILLING & INVOICES VIEW
             ============================================================ */}
          {activeView === "billing" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{lang === "zh" ? "费用总览与月度账单" : "Billing & Invoices"}</h1>
                  <p className="gc-view-subtitle">
                    {lang === "zh"
                      ? "集中查看企业实时计费消耗、按量付费明细、月度结算账单与官方增值税发票凭证。"
                      : "Manage real-time spend attribution, itemized service costs, monthly cycles and tax invoices."}
                  </p>
                </div>
                <div className="gc-view-actions">
                  <button
                    type="button"
                    className="gc-btn gc-btn-secondary"
                    onClick={() => showToast(lang === "zh" ? "已导出 2026年03月 实时账单消费明细 (CSV)" : "Exported statement (CSV)")}
                  >
                    <Icon name="download" size={14} />
                    <span>{lang === "zh" ? "导出本月对账单 (CSV)" : "Export Statement"}</span>
                  </button>
                  <button
                    type="button"
                    className="gc-btn gc-btn-primary"
                    onClick={() => showToast(lang === "zh" ? "月度预算预警阈值已设置为 $5,000.00 (达到80%时将触发企业微信/邮件告警)" : "Budget alert threshold updated")}
                  >
                    <Icon name="sliders" size={14} />
                    <span>{lang === "zh" ? "设置预算预警" : "Set Budget Alert"}</span>
                  </button>
                </div>
              </div>

              {/* Billing Top Metrics */}
              <div className="gc-metric-grid">
                <div className="gc-metric-card gc-billing-highlight-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "本月实时消费金额" : "Month-to-Date Cost"}</span>
                    <span className="gc-tag-blue">{lang === "zh" ? "实时计费中" : "Accruing"}</span>
                  </div>
                  <div className="gc-metric-value" style={{ color: "#2563eb", fontWeight: 700 }}>$1,248.60</div>
                  <div className="gc-metric-footer">
                    <span>{lang === "zh" ? "月预算 $5,000.00 (已使用 24.9%)" : "Budget $5,000.00 (24.9% used)"}</span>
                  </div>
                  <div className="gc-billing-pacing-bar">
                    <div className="gc-billing-pacing-fill" style={{ width: "24.9%" }}></div>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "上月已结算支出" : "Last Month Invoiced"}</span>
                    <Icon name="check" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">$3,892.40</div>
                  <div className="gc-metric-footer">
                    <span className="gc-trend-down">↓ 14.2%</span>
                    <span>{lang === "zh" ? "较前月环比优化" : "vs previous cycle"}</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "待入账按量账款" : "Unbilled Accrual"}</span>
                    <Icon name="usage" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">$64.20</div>
                  <div className="gc-metric-footer">
                    <span>{lang === "zh" ? "每日凌晨 02:00 自动汇总" : "Auto reconciled daily at 02:00"}</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "签约计费模式" : "Pricing Model"}</span>
                    <Icon name="shieldCheck" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value" style={{ fontSize: "1.25rem", marginTop: "4px" }}>
                    {lang === "zh" ? "企业专属阶梯价" : "Enterprise Tier"}
                  </div>
                  <div className="gc-metric-footer">
                    <span className="gc-tag-green">{lang === "zh" ? "享 8.8 折专属折扣" : "12% Enterprise Discount"}</span>
                  </div>
                </div>
              </div>

              {/* Product Cost Breakdown Section */}
              <div className="gc-panel-card" style={{ marginTop: "20px" }}>
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">{lang === "zh" ? "本月产品线支出细分" : "Monthly Spend by Service Line"}</h3>
                    <p className="gc-panel-subtitle">{lang === "zh" ? "按云服务产品线维度分类归集当前计费周期的实际支出" : "Itemized cost breakdown across AI, VOD streaming, and DRM infra"}</p>
                  </div>
                </div>
                <div className="gc-table-responsive">
                  <table className="gc-table">
                    <thead>
                      <tr>
                        <th>{lang === "zh" ? "产品服务线" : "Service Product"}</th>
                        <th>{lang === "zh" ? "计费规格 / 计量项" : "Billing Unit"}</th>
                        <th>{lang === "zh" ? "当月用量" : "Volume Consumed"}</th>
                        <th>{lang === "zh" ? "目录单价" : "Unit Rate"}</th>
                        <th>{lang === "zh" ? "本月金额" : "Amount (MTD)"}</th>
                        <th>{lang === "zh" ? "支出占比" : "Share"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mockProductCosts.map((p, idx) => (
                        <tr key={idx}>
                          <td><strong>{lang === "zh" ? p.service : p.serviceEn}</strong></td>
                          <td><code>{lang === "zh" ? p.unit : p.unitEn}</code></td>
                          <td>{p.usage}</td>
                          <td>{p.unitPrice}</td>
                          <td><strong style={{ color: "#2563eb" }}>{p.amount}</strong></td>
                          <td>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <div className="gc-billing-pacing-bar" style={{ width: "80px", margin: 0 }}>
                                <div className="gc-billing-pacing-fill" style={{ width: `${p.percentage}%` }}></div>
                              </div>
                              <span style={{ fontSize: "0.8rem", color: "#64748b" }}>{p.percentage}%</span>
                            </div>
                          </td>
                        </tr>
                      ))}
                      <tr style={{ background: "rgba(241, 245, 249, 0.6)", fontWeight: 600 }}>
                        <td colSpan="4"><strong>{lang === "zh" ? "本月账面支出总计 (Gross Total)" : "Gross Total"}</strong></td>
                        <td style={{ color: "#0f172a", fontSize: "1rem" }}><strong>$1,249.00</strong></td>
                        <td><span className="gc-table-tag">100.0%</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Monthly Bills & Invoices Table */}
              <div className="gc-panel-card" style={{ marginTop: "20px" }}>
                <div className="gc-panel-header">
                  <div>
                    <h3 className="gc-panel-title">{lang === "zh" ? "历史月度出账单与官方发票" : "Historical Monthly Invoices & Bills"}</h3>
                    <p className="gc-panel-subtitle">{lang === "zh" ? "可直接下载包含增值税信息的官方电子账单 PDF 或原始明细 CSV" : "Download certified PDF invoices and detailed itemization logs"}</p>
                  </div>
                </div>
                <div className="gc-table-responsive">
                  <table className="gc-table">
                    <thead>
                      <tr>
                        <th>{lang === "zh" ? "账单月份" : "Billing Cycle"}</th>
                        <th>{lang === "zh" ? "账单编号" : "Bill ID"}</th>
                        <th>{lang === "zh" ? "计费类型" : "Type"}</th>
                        <th>{lang === "zh" ? "账面金额" : "Gross"}</th>
                        <th>{lang === "zh" ? "协议优惠" : "Discounts"}</th>
                        <th>{lang === "zh" ? "实付结算" : "Net Paid"}</th>
                        <th>{lang === "zh" ? "状态" : "Status"}</th>
                        <th>{lang === "zh" ? "凭证与发票下载" : "Documents"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mockMonthlyInvoices.map((inv, idx) => (
                        <tr key={idx}>
                          <td><strong>{lang === "zh" ? inv.cycle : inv.cycleEn}</strong></td>
                          <td><code>{inv.id}</code></td>
                          <td><span className="gc-table-tag">{inv.mode}</span></td>
                          <td>{inv.gross}</td>
                          <td style={{ color: "#059669" }}>{inv.discount}</td>
                          <td><strong>{inv.net}</strong></td>
                          <td>
                            <span className={inv.status.includes("计费中") ? "gc-tag-blue" : "gc-tag-green"}>
                              {lang === "zh" ? inv.status : inv.statusEn}
                            </span>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="gc-btn gc-btn-ghost-sm"
                              onClick={() => showToast(lang === "zh" ? `正在下载 ${inv.id} 电子账单发票...` : `Downloading invoice for ${inv.id}...`)}
                            >
                              <Icon name="download" size={13} />
                              <span>{lang === "zh" ? inv.doc : inv.docEn}</span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ============================================================
              12. FINANCE & RECHARGE VIEW
             ============================================================ */}
          {activeView === "finance" && (
            <div className="gc-view-container">
              <div className="gc-view-header">
                <div>
                  <h1 className="gc-view-title">{lang === "zh" ? "企业财务记账与资金充值" : "Finance Ledger & Balance Top-up"}</h1>
                  <p className="gc-view-subtitle">
                    {lang === "zh"
                      ? "管理企业资金账户可用余额、资金明细流水台账、对公银行转账充值与发票抬头资质。"
                      : "Manage corporate account cash balance, ledger transactions, wire transfers and tax profile."}
                  </p>
                </div>
                <div className="gc-view-actions">
                  <button
                    type="button"
                    className="gc-btn gc-btn-primary"
                    onClick={() => setTopUpModalOpen(true)}
                  >
                    <Icon name="plus" size={14} />
                    <span>{lang === "zh" ? "企业在线充值" : "Top-up Balance"}</span>
                  </button>
                  <button
                    type="button"
                    className="gc-btn gc-btn-secondary"
                    onClick={() => showToast(lang === "zh" ? "已提交增值税专用发票开具申请，发票将在 1-2 工作日内寄出并发送电子版至财务邮箱" : "VAT invoice request submitted")}
                  >
                    <Icon name="billing" size={14} />
                    <span>{lang === "zh" ? "申请开具发票" : "Apply VAT Invoice"}</span>
                  </button>
                  <button
                    type="button"
                    className="gc-btn gc-btn-secondary"
                    onClick={() => setWireModalOpen(true)}
                  >
                    <Icon name="info" size={14} />
                    <span>{lang === "zh" ? "对公汇款指引" : "Wire Transfer Info"}</span>
                  </button>
                </div>
              </div>

              {/* Balance Strip */}
              <div className="gc-metric-grid">
                <div className="gc-metric-card gc-finance-balance-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "企业现金可用余额" : "Available Cash Balance"}</span>
                    <span className="gc-tag-green">{lang === "zh" ? "资金充足" : "Healthy"}</span>
                  </div>
                  <div className="gc-metric-value" style={{ color: "#059669", fontWeight: 700 }}>
                    ${enterpriseBalance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                  <div className="gc-metric-footer">
                    <span>{lang === "zh" ? "按当前日均消耗估算，可维持 182 天无忧运行" : "Estimated 182 days runway"}</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "信用授信额度" : "Credit Facility"}</span>
                    <Icon name="shieldCheck" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">$10,000.00</div>
                  <div className="gc-metric-footer">
                    <span>{lang === "zh" ? "月度免息授信 · 30天账期" : "30-day interest-free facility"}</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "冻结保证金" : "Reserved Escrow"}</span>
                    <Icon name="keys" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">$0.00</div>
                  <div className="gc-metric-footer">
                    <span>{lang === "zh" ? "无争议冻结或预扣押金" : "Zero escrow holds"}</span>
                  </div>
                </div>

                <div className="gc-metric-card">
                  <div className="gc-metric-header">
                    <span className="gc-metric-title">{lang === "zh" ? "年度累计开票" : "Total Invoiced (YTD)"}</span>
                    <Icon name="billing" size={16} className="gc-metric-icon" />
                  </div>
                  <div className="gc-metric-value">$58,200.00</div>
                  <div className="gc-metric-footer">
                    <span>{lang === "zh" ? "开票率 100% · 增值税专用发票" : "100% invoiced · Official VAT"}</span>
                  </div>
                </div>
              </div>

              {/* Finance Two Columns Grid */}
              <div className="gc-finance-grid" style={{ marginTop: "20px" }}>
                {/* Left: Financial Ledger Transactions */}
                <div className="gc-panel-card">
                  <div className="gc-panel-header">
                    <div>
                      <h3 className="gc-panel-title">{lang === "zh" ? "资金流水与记账台账" : "Financial Ledger & Transactions"}</h3>
                      <p className="gc-panel-subtitle">{lang === "zh" ? "每一笔充值入账、月结扣款与返利明细均有完备审计记录" : "Complete audit trail for all deposits, deductions, and adjustments"}</p>
                    </div>
                    <div className="gc-tab-pills">
                      <button
                        type="button"
                        className={`gc-tab-pill ${ledgerFilter === "all" ? "active" : ""}`}
                        onClick={() => setLedgerFilter("all")}
                      >
                        {lang === "zh" ? "全部流水" : "All"}
                      </button>
                      <button
                        type="button"
                        className={`gc-tab-pill ${ledgerFilter === "recharge" ? "active" : ""}`}
                        onClick={() => setLedgerFilter("recharge")}
                      >
                        {lang === "zh" ? "充值入账" : "Deposits"}
                      </button>
                      <button
                        type="button"
                        className={`gc-tab-pill ${ledgerFilter === "deduct" ? "active" : ""}`}
                        onClick={() => setLedgerFilter("deduct")}
                      >
                        {lang === "zh" ? "扣款结算" : "Deductions"}
                      </button>
                    </div>
                  </div>
                  <div className="gc-table-responsive">
                    <table className="gc-table">
                      <thead>
                        <tr>
                          <th>{lang === "zh" ? "交易时间" : "Time"}</th>
                          <th>{lang === "zh" ? "流水单号" : "Tx ID"}</th>
                          <th>{lang === "zh" ? "记账类型" : "Type"}</th>
                          <th>{lang === "zh" ? "变动金额" : "Amount"}</th>
                          <th>{lang === "zh" ? "账户余额" : "Balance"}</th>
                          <th>{lang === "zh" ? "经办 / 渠道" : "Channel / Ref"}</th>
                          <th>{lang === "zh" ? "状态" : "Status"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredLedger.map((tx, idx) => (
                          <tr key={idx}>
                            <td><code>{tx.time}</code></td>
                            <td><code>{tx.txId}</code></td>
                            <td><strong>{lang === "zh" ? tx.type : tx.typeEn}</strong></td>
                            <td>
                              <span style={{ color: tx.isCredit ? "#059669" : "#dc2626", fontWeight: 700 }}>
                                {tx.amount}
                              </span>
                            </td>
                            <td><strong>{tx.balance}</strong></td>
                            <td><span className="gc-table-tag">{lang === "zh" ? tx.channel : tx.channelEn}</span></td>
                            <td>
                              <span className="gc-tag-green">{lang === "zh" ? tx.status : tx.statusEn}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Right: Tax Profile & Payment Methods */}
                <div className="gc-finance-side-col">
                  {/* Tax Profile */}
                  <div className="gc-panel-card">
                    <div className="gc-panel-header">
                      <div>
                        <h3 className="gc-panel-title">{lang === "zh" ? "企业发票抬头与资质" : "Enterprise Tax Profile"}</h3>
                        <p className="gc-panel-subtitle">{lang === "zh" ? "增值税专用发票资质已通过核验" : "Verified Corporate Taxpayer"}</p>
                      </div>
                      <span className="gc-tag-green">{lang === "zh" ? "已认证" : "Verified"}</span>
                    </div>
                    <div className="gc-tax-details">
                      <div className="gc-tax-row">
                        <span className="gc-tax-label">{lang === "zh" ? "企业全称" : "Company"}:</span>
                        <span className="gc-tax-value">Goldly AI Technologies (Singapore) Pte. Ltd.</span>
                      </div>
                      <div className="gc-tax-row">
                        <span className="gc-tax-label">{lang === "zh" ? "统一税号 / UEN" : "Tax UEN"}:</span>
                        <span className="gc-tax-value"><code>202688991Z</code></span>
                      </div>
                      <div className="gc-tax-row">
                        <span className="gc-tax-label">{lang === "zh" ? "注册地址" : "Address"}:</span>
                        <span className="gc-tax-value">10 Marina Boulevard, MBFC Tower 2, Singapore</span>
                      </div>
                      <div className="gc-tax-row">
                        <span className="gc-tax-label">{lang === "zh" ? "开户银行" : "Bank"}:</span>
                        <span className="gc-tax-value">DBS Bank Ltd. (Singapore)</span>
                      </div>
                      <div className="gc-tax-row">
                        <span className="gc-tax-label">{lang === "zh" ? "银行账号" : "Account"}:</span>
                        <span className="gc-tax-value"><code>003-902-881920-1</code></span>
                      </div>
                      <div className="gc-tax-row">
                        <span className="gc-tax-label">{lang === "zh" ? "发票接收" : "Email"}:</span>
                        <span className="gc-tax-value">finance@goldly.ai</span>
                      </div>
                    </div>
                  </div>

                  {/* Payment Methods */}
                  <div className="gc-panel-card" style={{ marginTop: "16px" }}>
                    <div className="gc-panel-header">
                      <div>
                        <h3 className="gc-panel-title">{lang === "zh" ? "结算账户与支付渠道" : "Settlement Accounts"}</h3>
                      </div>
                    </div>
                    <div className="gc-payment-list">
                      <div className="gc-payment-item">
                        <div className="gc-payment-item-icon">
                          <Icon name="billing" size={18} />
                        </div>
                        <div className="gc-payment-item-info">
                          <div className="gc-payment-item-title">{lang === "zh" ? "企业公对公银企直联" : "DBS IDEAL Direct Debit"}</div>
                          <div className="gc-payment-item-desc">DBS Corporate Direct Debit · 已授权自动划扣</div>
                        </div>
                        <span className="gc-tag-blue">{lang === "zh" ? "默认扣款" : "Primary"}</span>
                      </div>
                      <div className="gc-payment-item">
                        <div className="gc-payment-item-icon">
                          <Icon name="creditCard" size={18} />
                        </div>
                        <div className="gc-payment-item-info">
                          <div className="gc-payment-item-title">{lang === "zh" ? "VISA 商务企业信用卡" : "Corporate VISA Card"}</div>
                          <div className="gc-payment-item-desc">•••• •••• •••• 8820 (Exp 09/28)</div>
                        </div>
                        <span className="gc-table-tag">{lang === "zh" ? "备用" : "Backup"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>

      {/* Top-up Balance Modal */}
      {topUpModalOpen && (
        <div className="gc-modal-backdrop" onClick={() => setTopUpModalOpen(false)}>
          <div className="gc-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="gc-modal-header">
              <h3 className="gc-modal-title">{lang === "zh" ? "企业资金账户在线充值" : "Top-up Corporate Balance"}</h3>
              <button
                type="button"
                className="gc-modal-close"
                onClick={() => setTopUpModalOpen(false)}
              >
                ✕
              </button>
            </div>
            <div className="gc-modal-body">
              <div className="gc-form-group">
                <label className="gc-form-label">{lang === "zh" ? "选择充值金额 (USD)" : "Select Amount (USD)"}</label>
                <div className="gc-amount-grid">
                  {[1000, 5000, 10000, 50000].map((amt) => (
                    <button
                      type="button"
                      key={amt}
                      className={`gc-amount-btn ${topUpAmount === amt ? "active" : ""}`}
                      onClick={() => setTopUpAmount(amt)}
                    >
                      ${amt.toLocaleString()}
                    </button>
                  ))}
                </div>
              </div>

              <div className="gc-form-group" style={{ marginTop: "16px" }}>
                <label className="gc-form-label">{lang === "zh" ? "选择付款渠道" : "Payment Channel"}</label>
                <div className="gc-channel-list">
                  <label className={`gc-channel-option ${topUpChannel === "wire" ? "selected" : ""}`}>
                    <input
                      type="radio"
                      name="topUpChannel"
                      value="wire"
                      checked={topUpChannel === "wire"}
                      onChange={(e) => setTopUpChannel(e.target.value)}
                    />
                    <div>
                      <strong>{lang === "zh" ? "DBS 企业电汇 (公对公即时到账)" : "DBS Corporate Wire"}</strong>
                      <p>{lang === "zh" ? "支持专属子账号自动核销与即时记账" : "Instant automated reconciliation"}</p>
                    </div>
                  </label>
                  <label className={`gc-channel-option ${topUpChannel === "card" ? "selected" : ""}`}>
                    <input
                      type="radio"
                      name="topUpChannel"
                      value="card"
                      checked={topUpChannel === "card"}
                      onChange={(e) => setTopUpChannel(e.target.value)}
                    />
                    <div>
                      <strong>{lang === "zh" ? "企业信用卡 (VISA •••• 8820)" : "Corporate Card (VISA •••• 8820)"}</strong>
                      <p>{lang === "zh" ? "扣款成功后实时可用" : "Instant settlement"}</p>
                    </div>
                  </label>
                </div>
              </div>

              <div className="gc-recharge-summary" style={{ marginTop: "16px" }}>
                <span>{lang === "zh" ? "充值后企业可用余额预估:" : "New Balance after Top-up:"}</span>
                <strong>${(enterpriseBalance + (Number(topUpAmount) || 0)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong>
              </div>
            </div>
            <div className="gc-modal-footer">
              <button
                type="button"
                className="gc-btn gc-btn-secondary"
                onClick={() => setTopUpModalOpen(false)}
              >
                {lang === "zh" ? "取消" : "Cancel"}
              </button>
              <button
                type="button"
                className="gc-btn gc-btn-primary"
                onClick={handleTopUpConfirm}
              >
                {lang === "zh" ? `确认充值 $${(Number(topUpAmount) || 0).toLocaleString()}` : "Confirm Top-up"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Wire Transfer Details Modal */}
      {wireModalOpen && (
        <div className="gc-modal-backdrop" onClick={() => setWireModalOpen(false)}>
          <div className="gc-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="gc-modal-header">
              <h3 className="gc-modal-title">{lang === "zh" ? "公对公银行电汇汇款指引" : "Wire Transfer Coordinates"}</h3>
              <button
                type="button"
                className="gc-modal-close"
                onClick={() => setWireModalOpen(false)}
              >
                ✕
              </button>
            </div>
            <div className="gc-modal-body">
              <p style={{ fontSize: "0.85rem", color: "#64748b", marginBottom: "16px" }}>
                {lang === "zh"
                  ? "请将款项汇入以下星展银行 (DBS) 专属机构账户。汇款时请务必在附言/备注中填入您的【组织识别码】，系统收到银行清算回执后将在 15 分钟内自动充值入账。"
                  : "Please remit funds to the following DBS corporate account. Include your Organization Reference Code in the remittance remarks for automatic reconciliation within 15 minutes."}
              </p>
              <div className="gc-tax-details">
                <div className="gc-tax-row">
                  <span className="gc-tax-label">{lang === "zh" ? "收款方全称" : "Beneficiary"}:</span>
                  <span className="gc-tax-value">Goldly AI Technologies (Singapore) Pte. Ltd.</span>
                </div>
                <div className="gc-tax-row">
                  <span className="gc-tax-label">{lang === "zh" ? "开户行 (Bank)" : "Bank"}:</span>
                  <span className="gc-tax-value">DBS Bank Ltd.</span>
                </div>
                <div className="gc-tax-row">
                  <span className="gc-tax-label">SWIFT / BIC:</span>
                  <span className="gc-tax-value"><code>DBSSSGSG</code></span>
                </div>
                <div className="gc-tax-row">
                  <span className="gc-tax-label">{lang === "zh" ? "银行账号" : "Account No."}:</span>
                  <span className="gc-tax-value"><code>003-902-881920-1</code></span>
                </div>
                <div className="gc-tax-row">
                  <span className="gc-tax-label">{lang === "zh" ? "汇款附言识别码 (必填)" : "Remittance Memo (Required)"}:</span>
                  <span className="gc-tax-value"><strong style={{ color: "#2563eb" }}>GOLDLY-ORG-88219</strong></span>
                </div>
              </div>
            </div>
            <div className="gc-modal-footer">
              <button
                type="button"
                className="gc-btn gc-btn-primary"
                onClick={() => {
                  handleCopy("Beneficiary: Goldly AI Technologies (Singapore) Pte. Ltd.\nBank: DBS Bank Ltd.\nSWIFT: DBSSSGSG\nAccount: 003-902-881920-1\nMemo: GOLDLY-ORG-88219");
                  setWireModalOpen(false);
                }}
              >
                {lang === "zh" ? "复制全部电汇信息" : "Copy Remittance Info"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
